<template>
  <div>
    <div v-if="showAdvanceds">
      <el-dialog
        ref="eventDialog"
        :visible.sync="info.show"
        :close-on-click-modal="false"
        width="720px"
        append-to-body
        :show-close="eventReuse ? false : true"
        :modal="false"
        class="thisblack-bgc"
        :class="{ showGroup: showGroupLink, noShowGroup: !showGroupLink }"
        @close="done"
      >
        <div slot="title" class="dialog-title">
          <div>
            <span v-if="eventReuse">
              <i class="el-icon-warning"></i>
              <span >This event is done.</span>
            </span>
            <span v-else>{{dialogTitle}}</span>
          </div>
          <div class="titleBtn" v-if="eventReuse">
            <el-button href="javascript:void(0);" class="reuseCancel" v-if="!showGroupLink" @click="done">{{ $t("leftPane.cancel") }}</el-button>
            <template v-if="producerSettingsDto.elasticIp && !isReuse">
              <el-button class="releaseIpBtn" v-if="!isUnbind" disabled>Release IP</el-button>
              <el-tooltip
                v-else
                effect="light"
                content="Click to make the Elastic IP idle."
                placement="top"
                popper-class="toolTipsItem"
              >
                <el-button @click="unBindElasticIP" class="releaseIpBtn">Release IP</el-button>
              </el-tooltip>
            </template>
            <el-button
              href="javascript:void(0);"
              class="reuseBtn"
              @click="reuseEvent"
            >
              {{ $t("eventList.reuse") }}
            </el-button>
          </div>
        </div>
        <div class="content" v-if="!showGroupLink" v-loadings="scrollS.loading">
          <div class="serviceUrl" v-if="info.id && eventInfo.status <= 4">
            <div class="mixer" v-if="audioMixer">
              <div class="audio">
                <p>{{ $t("eventList.advancedAudioMixer") }}</p>
                <div class="url">
                  <a :href="audioMixer" target="_blank">{{ audioMixer }}</a>
                </div>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('eventList.copyLink')"
                  placement="top"
                >
                  <span
                    class="link el-icon-connection"
                    v-clipboard:copy="copyLink(audioMixer)"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                  ></span>
                </el-tooltip>
              </div>
            </div>
            <div class="mixer" v-if="eventInfo.ppUrl && eventInfo.status == 4">
              <div class="audio">
                <p>{{ $t("coordinationRoom.producer") }}</p>
                <div class="url">
                  <a :href="eventInfo.ppUrl" target="_blank">{{
                    eventInfo.ppUrl
                  }}</a>
                </div>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('eventList.copyLink')"
                  placement="top"
                >
                  <span
                    class="link el-icon-connection"
                    v-clipboard:copy="copyLink(eventInfo.ppUrl)"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                  ></span>
                </el-tooltip>
              </div>
            </div>
            <div class="mixer" v-if="info.id">
              <div class="audio">
                <p>{{ $t("coordination") }}</p>
                <div class="url">
                  <a :href="coordinationUrl" target="_blank">{{
                    coordinationUrl
                  }}</a>
                </div>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('eventList.copyLink')"
                  placement="top"
                >
                  <span
                    class="link el-icon-connection"
                    v-clipboard:copy="copyLink(coordinationUrl)"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                  ></span>
                </el-tooltip>
              </div>
            </div>
          </div>
          <el-divider v-if="info.id && eventInfo.status <= 4"></el-divider>
          <!-- 显示 event name -->
          <div class="title eventName">
            <span class="label"
              ><i class="require">*</i>{{ $t("eventList.eventName") }}</span
            >
            <el-input
              v-model="title"
              :placeholder="$t('eventList.addTitle')"
              :maxlength="32"
              :disabled="
                (isReuse ? false : info.type == 'reuse' || eventInfo.status == 4) || eventInfo.collaborateType == '2'
              "
              class="eventName"
            ></el-input>
          </div>
          <!-- 选择事件时间 -->
          <div class="title eventTime" v-if="timeControl">
            <span class="label"
              ><i class="require">*</i>{{ $t("eventList.time") }}</span
            >
            <el-date-picker
              v-model="startTime"
              type="datetime"
              :clearable="false"
              format="yyyy-MM-dd HH:mm"
              value-format="timestamp"
              :default-time="new Date().getTime() | FormatTime('HH:mm:ss')"
              :picker-options="startDatePickerOptions"
              align="center"
              :disabled="
               (!isReuse && (info.type == 'reuse' || (eventInfo.status && eventInfo.status != 1 && eventInfo.status != 2))) ? true : false
              "
              :placeholder="$t('eventList.startTime')"
              @change="changeStartTime"
            >
            </el-date-picker>
            <span class="sign">-</span>
            <el-date-picker
              align="center"
              popper-class="endTime"
              v-model="endTime"
              type="datetime"
              :disabled="(!isReuse && info.type == 'reuse') ? true : false"
              :clearable="false"
              @change="changeEndTime"
              format="yyyy-MM-dd HH:mm"
              value-format="timestamp"
              :picker-options="endDatePickerOptions"
              :default-time="new Date().getTime() | FormatTime('HH:mm:ss')"
              :placeholder="$t('eventList.endTime')"
            >
            </el-date-picker>
            <span style="display: inline-block; margin-left: 14px">
              <span
                class="set_now_icon"
                :class="{
                  notAllowed:
                    !isReuse && (info.type === 'reuse' || info.type === 'edit'),
                }"
                @click="resetTime('now')"
                >{{ $t("eventList.now") }}
              </span>
            </span>
          </div>
          <!-- 选择 now 30 分钟的时间 -->
          <div class="title duration_box eventTime" v-else>
            <span class="label"
              ><i class="require">*</i>{{ $t("eventList.time") }}</span
            >
            <span>{{ $t("eventList.now") }}</span>
            <span class="label duration">{{ $t("eventList.duration") }}</span>
            <el-dropdown
              trigger="click"
              @command="changeDuration"
              placement="bottom"
              style="margin-left: 4px; width: 100px"
            >
              <el-input
                class="el-dropdown-link duration_input"
                v-model.number="duration"
                @change="changeTime"
              ></el-input>
              <div class="unit">{{ durationType.unit | showTimeUnit }}</div>
              <el-dropdown-menu slot="dropdown" class="time_dropdown">
                <el-dropdown-item
                  v-for="(val, key) in durationTime"
                  :command="val"
                  :key="key"
                  >{{ val.time }}
                  {{ val.unit | showTimeUnit }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
            <div style="display: inline-block; margin-left: 12px">
              <span
                class="set_now_icon"
                :class="{
                  notAllowed:
                    !isReuse && (info.type === 'reuse' || info.type === 'edit'),
                }"
                @click="resetTime('reset')"
                >{{ $t("eventList.reset") }}</span
              >
            </div>
          </div>
          <el-divider></el-divider>
          <!-- 选择 cloudR 还是 Receiver -->
          <div
            class="receiverBox"
            :class="{
              active: showActiveBackground,
              receiverBackup:
                receiverType == '1' && purpose == 1 && receiverBackupBtnVal,
            }"
          >
            <!-- input R type -->
            <div class="title">
              <span class="label">
                <i class="require">*</i>{{ $t("coordinationRoom.inputRType") }}
              </span>
              <!-- 选择是使用物理 R 还是 cloud R 的下拉框 -->
              <div class="inputType receiverTypeSelect">
                <el-select
                  v-model="receiverType"
                  popper-class="black"
                  @change="defaultSet"
                  :disabled="
                    (info.type == 'reuse'
                      ? true
                      : false || eventInfo.status == '4'
                      ? true
                      : false)
                      || eventInfo.collaborateType =='2'
                  "
                  :popper-append-to-body="false"
                >
                  <el-option
                    v-for="item in rTypeList"
                    :key="item.val"
                    :label="$t(`coordinationRoom.${item.label}`)"
                    :value="item.val"
                  >
                  </el-option>
                </el-select>
              </div>
              <!-- 选择物理 R 时的下拉框 -->
              <div class="receiverType" v-show="receiverType == '1'">
                <el-select
                  v-if="eventInfo.collaborateType != '2'"
                  remote
                  :placeholder="$t('eventList.ReceiverSelect')"
                  v-model="receiverPeerId"
                  popper-class="black"
                  @input="getRList(receiverPeerId, 'main')"
                  v-scroll="scroll"
                  :loading="loading"
                  :filterable="true"
                  :filter-method="
                    (val) => {
                      getReceiverList('filter', val);
                    }
                  "
                  @visible-change="
                    (val) => {
                      getReceiverList('getList', val);
                    }
                  "
                  :disabled="
                    (isReuse
                      ? false
                      : info.type == 'reuse' || eventInfo.status == '4'
                      ? true
                      : false)
                  "
                  :popper-append-to-body="false"
                  ref="ruleSelect"
                >
                  <el-option
                    v-for="item in rList"
                    :key="item.peerId"
                    :label="item.name"
                    :value="item.peerId"
                    :disabled="
                      receiverBackupBtnVal &&
                      backupReceiverPeerId === item.peerId
                    "
                  >
                    <div @click="clickReceiverPeerId(item)">
                      {{ item.name }}
                    </div>
                  </el-option>
                  <p
                    class="loading-txt"
                    v-if="scroll.loading"
                    style="text-align: center; font-size: 15px; color: #909090"
                  >
                    <i class="el-icon-loading" style="color: #909090"></i>
                    {{ $t("eventList.loading") }}
                  </p>
                </el-select>
                <el-select
                  v-else-if="eventInfo.collaborateType == '2'&& eventInfo.inputList[0].value"
                  v-model="eventInfo.inputList[0].value.id"
                  :disabled="true"
                >
                  <el-option
                    :label="eventInfo.inputList[0].value.receiverName"
                    :value="eventInfo.inputList[0].value.id"
                  />
                </el-select>
              </div>
              <!-- 选择物理 R 时对 R 的功能校验 -->
              <checkRFeature
                ref="receiverCheckFeature"
                :receiverMainOrBack="'mainReceiver'"
                v-if="receiverType == '1'"
              ></checkRFeature>
            </div>
            <!-- input 输入源类型区域 -->
            <div class="title">
              <span class="label"
                ><i class="require">*</i>{{ $t("leftPane.input") }}</span
              >
              <!-- 没有选择物理 R 时显示 -->
              <div
                class="inputType"
                v-show="receiverType != '1'"
                :class="{ width330: inputType == 'pgm' }"
              >
                <select-menu
                  :data="inputTypeList"
                  type="group"
                  @callBack="(val) => { changeInputType(val, '') }"
                  :callback="(val) => { changeInputType(val, '')}"
                  :disabledMessage="disabledMessage"
                  :selectVal="inputType"
                  :disabled="
                    (isReuse ? false : info.type == 'reuse' ? true : false) || eventInfo.collaborateType == '2' || (inputType === 'pgm' && productionRedundancy && !!info.id)
                  "
                ></select-menu>
              </div>
              <!-- 选择物理 R 时显示 R 的 input 类型 -->
              <div class="inputType" v-show="receiverType == '1'">
                <el-select
                  :popper-append-to-body="false"
                  v-model="receiverInputType"
                  popper-class="black"
                  @change="
                    (val) => {
                      getSourceInfo(val, 'main');
                    }
                  "
                  :disabled="
                    (isReuse ? false : info.type == 'reuse' ? true : false) || eventInfo.collaborateType == '2'
                  "
                >
                  <el-option
                    v-for="item in typeList"
                    :key="item.val"
                    :label="item.label"
                    :value="item.val"
                  >
                  </el-option>
                </el-select>
              </div>
              <!-- input 第二个输入框 -->
              <div class="inputList" v-if="inputType != 'pgm'">
                <!-- 选择类型是 file 时显示 -->
                <SelectScrollFile
                  v-if="inputType == 'file' && eventInfo.collaborateType != '2'"
                  :info="fileInfo"
                  @callback="(val) => {selectInputChange(val);}"
                  :disabled="isReuse ? false : info.type == 'reuse' ? true : false"
                />
                <el-select
                  v-else-if="inputType == 'file' && eventInfo.collaborateType == '2'&& eventInfo.inputList[0].value"
                  v-model="eventInfo.inputList[0].value.id"
                  :disabled="true"
                >
                  <el-option
                    :label="eventInfo.inputList[0].value.name"
                    :value="eventInfo.inputList[0].value.id"
                  />
                </el-select>
                <!-- 选择类型不是 file 并且 request.url 有值时显示 -->
                <SelectScroll
                  ref="selectScroll"
                  v-if="inputType != 'file' && requestInfo.url"
                  :eventInfo="eventInfo"
                  :receiverPeerId="receiverPeerId"
                  :receiverInputType="receiverInputType"
                  :info="requestInfo"
                  :type="inputType"
                  :backupBtnVal="backupBtnVal"
                  :disabledList="disableInputSlot"
                  :disabledMessage="disabledInputSlotMessage"
                  @openRtmp="showRtmp"
                  @openRtmpBackUp="showRtmpBackUp"
                  @callback="
                    (val) => {
                      selectInputChange(val);
                    }
                  "
                  :disabled="
                    (isReuse ? false : info.type == 'reuse' ? true : false) || eventInfo.collaborateType == '2'
                  "
                />
              </div>
              <!-- 选择类型不是 pgm 并且也不是物理 R 时的 backup 勾选框 -->
              <div
                class="backup"
                v-if="inputType != 'pgm' && receiverType != '1'"
              >
                <el-checkbox
                  v-model="backupBtnVal"
                  :disabled="
                    (isReuse ? false : info.type == 'reuse' ? true : false)||eventInfo.collaborateType == '2'
                  "
                  @change="changeBackupBtn"
                  >{{ $t("eventList.backUp") }}</el-checkbox
                >
              </div>
              <!-- 选择为物理 R 时的 backup 勾选框 -->
              <div class="receiverBackup" v-if="receiverType == '1'">
                <el-checkbox
                  v-model="receiverBackupBtnVal"
                  :disabled="
                    (isReuse
                      ? false
                      : info.type == 'reuse' || info.type == 'edit'
                      ? true
                      : false) || eventInfo.collaborateType == '2'
                  "
                  @change="changeBackupBtn"
                  >{{ $t("eventList.backUp") }}</el-checkbox
                >
              </div>
            </div>
            <!-- output 区域 -->
            <div class="title output" v-show="receiverPeerId">
              <span class="label">{{ $t("eventList.outputs") }}</span>
              <div class="sdiOutput">SDI OUT</div>
              <div class="receiverName">{{ receiverOutputName }}</div>
            </div>
          </div>
          <!-- back receiver 区域 -->
          <div
            class="backupReceiverBox"
            v-if="receiverType == '1' && receiverBackupBtnVal"
            :class="{ active: purpose == 2 && receiverBackupBtnVal }"
          >
            <!-- backup 物理 R 的选择 -->
            <div
              class="title"
              v-if="receiverType == '1' && receiverBackupBtnVal"
            >
              <span class="label">{{ $t("eventList.backupReceiver") }}</span>
              <!--物理R的提示框-->
              <div class="backupReceiver">
                <el-select
                 v-if="eventInfo.collaborateType != '2'"
                  remote
                  :placeholder="$t('eventList.ReceiverSelect')"
                  v-model="backupReceiverPeerId"
                  popper-class="black"
                  @input="getRList(backupReceiverPeerId, 'backup')"
                  v-scroll="backupScroll"
                  :loading="backupLoading"
                  :filterable="true"
                  :filter-method="
                    (val) => {
                      getBackupReceiverList('filter', val);
                    }
                  "
                  @visible-change="
                    (val) => {
                      getBackupReceiverList('getList', val);
                    }
                  "
                  :disabled="
                    (isReuse
                      ? false
                      : info.type == 'reuse' || eventInfo.status == '4'
                      ? true
                      : false)
                  "
                  :popper-append-to-body="false"
                  ref="ruleSelect"
                >
                  <el-option
                    v-for="item in backupRList"
                    :key="item.peerId"
                    :label="item.name"
                    :value="item.peerId"
                    :disabled="receiverPeerId === item.peerId"
                  >
                    <div @click="clickBackupReceiverPeerId(item)">
                      {{ item.name }}
                    </div>
                  </el-option>
                  <p
                    class="loading-txt"
                    v-if="backupScroll.loading"
                    style="text-align: center; font-size: 15px; color: #909090"
                  >
                    <i class="el-icon-loading" style="color: #909090"></i>
                    {{ $t("eventList.loading") }}
                  </p>
                </el-select>
                <el-select v-else-if="eventInfo.collaborateType == '2' && eventInfo.inputList[1] && eventInfo.inputList[1].value" v-model="eventInfo.inputList[1].value.id"
                          :disabled="true">
                  <el-option :label="eventInfo.inputList[1].value.receiverName" :value="eventInfo.inputList[1].value.id"/>
                </el-select>
              </div>
              <!--问号的提示信息-->
              <checkRFeature
                ref="backupReceiverCheckFeature"
                :receiverMainOrBack="'backReceiver'"
                :receiverType="receiverType"
              ></checkRFeature>
            </div>
            <!-- bkp inpurt -->
            <div
              class="title"
              v-if="receiverType == '1' && receiverBackupBtnVal"
            >
              <span class="label"
                ><i class="require">*</i>{{ $t("eventList.bkpInput") }}</span
              >
              <!-- backup 物理 R 输入类型的选择 -->
              <div class="inputType">
                <el-select
                  :popper-append-to-body="false"
                  v-model="backupReceiverInputType"
                  popper-class="black"
                  @change="
                    (val) => {
                      getSourceInfo(val, 'backup');
                    }
                  "
                  :disabled="
                    (isReuse ? false : info.type == 'reuse' ? true : false) || eventInfo.collaborateType == '2'
                  "
                >
                  <el-option
                    v-for="item in backUpInTypeList"
                    :key="item.val"
                    :label="item.label"
                    :value="item.val"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="inputList" v-if="inputType != 'pgm'">
                <SelectScroll
                  ref="backupSelectScroll"
                  v-if="inputType != 'file' && backupRequestInfo.url"
                  :eventInfo="eventInfo"
                  :receiverPeerId="backupReceiverPeerId"
                  :receiverInputType="backupReceiverInputType"
                  :info="backupRequestInfo"
                  :type="inputType"
                  :disabledList="disableInputSlot"
                  :disabledMessage="disabledInputSlotMessage"
                  @openRtmp="showRtmp"
                  @openRtmpBackUp="showRtmpBackUp"
                  @callback="
                    (val) => {
                      selectInputChange(val, '', 'backupReceiver');
                    }
                  "
                  :disabled="
                    (isReuse ? false : info.type == 'reuse' ? true : false) || eventInfo.collaborateType == '2'
                  "
                />
              </div>
            </div>
            <!-- back receiver output 区域 -->
            <div
              class="title output"
              v-show="
                receiverType == '1' &&
                backupReceiverPeerId &&
                receiverBackupBtnVal
              "
            >
              <span class="label">{{ $t("eventList.outputs") }}</span>
              <div class="sdiOutput">SDI OUT</div>
              <div class="receiverName">{{ backupReceiverOutputName }}</div>
            </div>
          </div>
          <!-- 类型不是 pgm 时的 backup 源的选择 -->
          <div
            class="title ppRBackup"
            :class="{ active: purpose == 2 }"
            v-if="backupBtnVal && inputType != 'pgm'"
          >
            <span class="label">{{ $t("eventList.bkpInput") }}</span>
            <div class="inputType" :class="{ width330: backupType == 'pgm' }">
              <select-menu
                :data="backupTypeList"
                :disabledMessage="disabledBackMessage"
                type="group"
                :disabled="
                  (isReuse
                    ? false
                    : info.type == 'reuse' || inputType == 'pgm'
                    ? true
                    : false) || eventInfo.collaborateType == '2'
                "
                :callback="
                  (val) => {
                    changeInputType(val, 'backup');
                  }
                "
                @callBack="
                  (val) => {
                    changeInputType(val, 'backup');
                  }
                "
                :selectVal="backupType"
              ></select-menu>
            </div>
            <div class="inputList" v-if="backupType != 'pgm'">
              <SelectScrollFile
                v-if="backupType == 'file' && eventInfo.collaborateType != '2'"
                :info="backupFileInfo"
                @callback="
                  (val) => {
                    selectInputChange(val, 'backup');
                  }
                "
                :disabled="isReuse ? false : info.type == 'reuse' ? true : false"
              />
              <el-select v-else-if="inputType == 'file' && eventInfo.collaborateType == '2'&& eventInfo.inputList[1].value" v-model="eventInfo.inputList[1].value.id"
                          :disabled="true">
                  <el-option :label="eventInfo.inputList[1].value.name" :value="eventInfo.inputList[1].value.id"/>
                </el-select>
              <SelectScroll
                v-if="backupType != 'file'"
                ref="backupSelectScroll"
                :eventInfo="eventInfo"
                :backType="backType"
                :key="backupType"
                :backupBtnVal="backupBtnVal"
                :type="backupType"
                :info="requestBackupInfo"
                :disabledList="disableBackInputSlot"
                :disabledMessage="disabledBackInputSlotMessage"
                @openRtmp="showRtmp"
                @openRtmpBackUp="showRtmpBackUp"
                @callback="
                  (val) => {
                    selectInputChange(val, 'backup');
                  }
                "
                :disabled="(isReuse ? false : info.type == 'reuse' ? true : false) || eventInfo.collaborateType == '2'"
              />
            </div>
          </div>
          <!-- input select 输入的选择 -->
          <div
            class="title"
            v-if="showSwitchInput"
          >
            <span class="label">{{ $t("eventList.inputSelect") }}</span>
            <span
              class="backupBtn"
              :class="{
                active: purpose == 1,
                disabled: isReuse ? false : info.type == 'reuse',
              }"
              @click="selectSourceType(1)"
              >{{ $t("eventList.mainIn") }}</span
            >
            <span
              class="backupBtn"
              :class="{
                active: purpose == 2,
                disabled: isReuse ? false : info.type == 'reuse',
              }"
              @click="selectSourceType(2)"
              >{{ $t("eventList.backUpIn") }}</span
            >
            <span
              v-if="eventInfo.status == 4 && eventInfo.inputList.length == 2"
              class="backupBtn applyBtn"
              :class="{ showgray: !activeApply }"
              @click="applyInputType()"
              >{{ $t("eventList.apply") }}</span
            >
          </div>
          <el-divider v-if="receiverType != '1' && providerList.length >= 2"></el-divider>
          <!--Cloud provider镜像-->
          <div class="cloudeProvider title" v-show="receiverType != '1' && providerList.length >= 2">
            <span class="label">{{ $t("eventList.cloudeProvider") }}</span>
            <el-select
              v-model="producerSettingsDto.platform"
              :placeholder="$t('otherWords.selectCloudProvider')"
              popper-class="black"
              :disabled="
                !!info.id ||
                (inputType == 'file' ||
                (eventInfo.status && eventInfo.status == 4)
                  ? true
                  : false)
              "
              class="regions"
              @change="getRegionList('switchProvider')"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item in providerList"
                :key="item.platform"
                :label="$t('cloudProvider.' + item.code)"
                :value="String(item.platform)"
              >
              </el-option>
            </el-select>
          </div>
          <!-- elastic ip 区域 -->
          <div class="title elasticIP m_t_10" v-show="receiverType != '1'">
            <span class="leftItem">
              <el-tooltip
                effect="light"
                placement="top"
                popper-class="toolTipsItem"
              >
                <div slot="content" v-if="hasElasticIp">
                  {{ $t("otherWords.contactSupport") }}
                </div>
                <div slot="content" v-else>
                  {{ $t("otherWords.elasticIpExplain") }}
                </div>
                <i class="el-icon-question"></i>
              </el-tooltip>
              <span class="text">{{ $t("otherWords.elasticIp") }}</span>
              <el-checkbox
                v-model="isShowElasticIP"
                :disabled="
                componentDisabled ||
                  (hasElasticIp || editElasticIP || eventInfo.status == 4)
                "
              ></el-checkbox>
              <span class="verticalLine"></span>
            </span>
            <span class="rightItem" v-if="!isShowElasticIP">
              <div class="regionAndZone">
                <div class="region" :style="{'width':userFeature.zoneControl == 1 && producerSettingsDto.platform == 1 ? '':'100%'}">
                  <span class="label">{{ $t("eventList.region") }}</span>
                  <el-select
                    v-model="producerSettingsDto.region"
                    :placeholder="$t('otherWords.selectRegion')"
                    popper-class="black"
                    :disabled="
                      componentDisabled ||
                      (inputType == 'file' ||
                      (eventInfo.status && eventInfo.status == 4)
                        ? true
                        : false)
                    "
                    class="regions"
                    :popper-append-to-body="false"
                    @change="getZoneList('main')"
                  >
                    <el-option
                      v-for="item in regionList"
                      :key="item.value"
                      :label="item.name | showRegion"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="zone" v-if="userFeature.zoneControl == 1 && producerSettingsDto.platform == 1">
                  <span class="label">{{ $t("eventList.zone") }}</span>
                  <el-select
                    v-model="producerSettingsDto.zone"
                    :placeholder="$t('otherWords.selectZone')"
                    popper-class="black"
                    :loading="zoneLoading"
                    :disabled="
                      componentDisabled ||
                      (eventInfo.status && eventInfo.status == 4)
                    "
                    class="regions"
                    :popper-append-to-body="false"
                  >
                    <el-option
                      v-for="item in zoneList"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </span>
            <!-- elasticIP显示 -->
            <span class="rightItem" v-else>
              <span class="label">{{ $t("otherWords.selectIp") }}</span>
              <el-select
                v-model="producerSettingsDto.elasticIp"
                :placeholder="$t('otherWords.pleaseSelect')"
                popper-class="black"
                :disabled="
                  componentDisabled ||
                  (inputType == 'file' ||
                  hasElasticIp ||
                  editElasticIP ||
                  eventInfo.status == 4
                    ? true
                    : false)
                "
                class="regions"
                @change="showTips"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="item in elasticIpList"
                  :key="item.value.id"
                  :label="item.elasticIpAndRegions"
                  :value="item.value.staticIp"
                  :disabled="item.disabled"
                >
                  <span
                    style="float: left; color: #555661"
                    v-if="item.value.occupied"
                    >{{ item.elasticIpAndRegions }}</span
                  >
                  <span style="float: left; color: #f1f1f1" v-else>{{
                    item.elasticIpAndRegions
                  }}</span>
                  <el-tooltip
                    class="item"
                    effect="light"
                    placement="top"
                    popper-class="toolTipsItem"
                    v-if="item.value.occupied"
                  >
                    <div
                      slot="content"
                      v-if="item.value.occupiedInfo.type === 'rc'"
                    >
                      The IP is occupied by
                      {{ '"' + item.value.occupiedInfo.name + '"' }}.
                    </div>
                    <div slot="content" v-else>
                      {{ $t("otherWords.ipOccupiedByProducer") }}
                      {{ '"' + item.value.occupiedInfo.name + '"' }}
                      {{ $t("otherWords.ofProducer") }}
                    </div>
                    <span style="float: right; color: #555661; font-size: 13px"
                      >occupied</span
                    >
                  </el-tooltip>
                </el-option>
              </el-select>
            </span>
          </div>
          <!-- Production Redundancy 区域 -->
          <div class="title productionRedundancy" v-show="inputType == 'pgm' && receiverType != '1'">
            <span class="label">Production Redundancy</span>
            <el-checkbox
              v-model="productionRedundancy"
              :disabled="componentDisabled || eventInfo.status == 4 || (productionRedundancy && !!info.id)"
              @change="changeProductionRedundancy"
            ></el-checkbox>
            <el-tooltip
              effect="light"
              placement="top"
              popper-class="toolTipsItem"
            >
              <div slot="content">
                When enabled, a second production will be deployed. It can be deployed in a different region. The option increases the cost of the event.
              </div>
              <i class="el-icon-question" style="margin-left: 4px; color: #909399; cursor: pointer;"></i>
            </el-tooltip>
            <span class="redundancy-desc">
              When enabled, a second production will be deployed. It can be deployed in a different region. The option increases the cost of the event.
            </span>
          </div>
          <!-- backup elastic ip 区域 (pgm backup) -->
          <div class="title elasticIP" v-show="receiverType != '1' && inputType == 'pgm' && productionRedundancy">
            <span class="leftItem">
              <el-tooltip
                effect="light"
                placement="top"
                popper-class="toolTipsItem"
              >
                <div slot="content" v-if="hasElasticIp">
                  {{ $t("otherWords.contactSupport") }}
                </div>
                <div slot="content" v-else>
                  {{ $t("otherWords.elasticIpExplain") }}
                </div>
                <i class="el-icon-question"></i>
              </el-tooltip>
              <span class="text">{{ $t("otherWords.elasticIp") }}</span>
              <el-checkbox
                v-model="isShowBackupElasticIP"
                :disabled="
                componentDisabled ||
                  (hasElasticIp || editElasticIP || eventInfo.status == 4)
                "
              ></el-checkbox>
              <span class="verticalLine"></span>
            </span>
            <span class="rightItem" v-if="!isShowBackupElasticIP">
              <div class="regionAndZone">
                <div class="region" :style="{'width':userFeature.zoneControl == 1 && producerSettingsDto.platform == 1 ? '':'100%'}">
                  <span class="label">{{ $t("eventList.region") }}</span>
                  <el-select
                    v-model="backupRegion"
                    :placeholder="$t('otherWords.selectRegion')"
                    popper-class="black"
                    :disabled="
                      componentDisabled ||
                      (inputType == 'file' ||
                      (eventInfo.status && eventInfo.status == 4)
                        ? true
                        : false)
                    "
                    class="regions"
                    :popper-append-to-body="false"
                    @change="getZoneList('backup')"
                  >
                    <el-option
                      v-for="item in regionList"
                      :key="item.value"
                      :label="item.name | showRegion"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="zone" v-if="userFeature.zoneControl == 1 && producerSettingsDto.platform == 1">
                  <span class="label">{{ $t("eventList.zone") }}</span>
                  <el-select
                    v-model="backupZone"
                    :placeholder="$t('otherWords.selectZone')"
                    popper-class="black"
                    :loading="backupZoneLoading"
                    :disabled="
                      componentDisabled ||
                      (eventInfo.status && eventInfo.status == 4)
                    "
                    class="regions"
                    :popper-append-to-body="false"
                  >
                    <el-option
                      v-for="item in backupZoneList"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </span>
            <!-- backup elasticIP显示 -->
            <span class="rightItem" v-else>
              <span class="label">{{ $t("otherWords.selectIp") }}</span>
              <el-select
                v-model="backupElasticIp"
                :placeholder="$t('otherWords.pleaseSelect')"
                popper-class="black"
                :disabled="
                  componentDisabled ||
                  (inputType == 'file' ||
                  hasElasticIp ||
                  editElasticIP ||
                  eventInfo.status == 4
                    ? true
                    : false)
                "
                class="regions"
                @change="showTips"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="item in elasticIpList"
                  :key="item.value.id"
                  :label="item.elasticIpAndRegions"
                  :value="item.value.staticIp"
                  :disabled="item.disabled"
                >
                  <span
                    style="float: left; color: #555661"
                    v-if="item.value.occupied"
                    >{{ item.elasticIpAndRegions }}</span
                  >
                  <span style="float: left; color: #f1f1f1" v-else>{{
                    item.elasticIpAndRegions
                  }}</span>
                  <el-tooltip
                    class="item"
                    effect="light"
                    placement="top"
                    popper-class="toolTipsItem"
                    v-if="item.value.occupied"
                  >
                    <div
                      slot="content"
                      v-if="item.value.occupiedInfo.type === 'rc'"
                    >
                      The IP is occupied by
                      {{ '"' + item.value.occupiedInfo.name + '"' }}.
                    </div>
                    <div slot="content" v-else>
                      {{ $t("otherWords.ipOccupiedByProducer") }}
                      {{ '"' + item.value.occupiedInfo.name + '"' }}
                      {{ $t("otherWords.ofProducer") }}
                    </div>
                    <span style="float: right; color: #555661; font-size: 13px"
                      >occupied</span
                    >
                  </el-tooltip>
                </el-option>
              </el-select>
            </span>
          </div>
          <!-- Production Select 双pgm场景下的输入选择 -->
          <div
            class="title productionSelect"
            v-if="inputType == 'pgm' && productionRedundancy && receiverType != '1'"
          >
            <span class="label">{{ $t("eventList.productionSelect") }}</span>
            <span
              class="backupBtn"
              :class="{
                active: purpose == 1,
                disabled: isReuse ? false : info.type == 'reuse',
              }"
              @click="selectSourceType(1)"
              >{{ $t("coordinationRoom.productionMainIn") }}</span
            >
            <span
              class="backupBtn"
              :class="{
                active: purpose == 2,
                disabled: isReuse ? false : info.type == 'reuse',
              }"
              @click="selectSourceType(2)"
              >{{ $t("coordinationRoom.productionEventBackUp") }}</span
            >
            <span
              v-if="eventInfo.status == 4 && eventInfo.inputList.length == 2"
              class="backupBtn applyBtn"
              :class="{ showgray: !activeApply }"
              @click="applyInputType()"
              >{{ $t("eventList.apply") }}</span
            >
          </div>
          <el-divider v-if="receiverType != '1'"></el-divider>
          <!-- 输出 -->
          <div class="title outputBox" v-show="receiverType != '1'">
            <span class="label">{{ $t("eventList.outputs") }}</span>
            <!-- <span class="selectedNum"
          >({{ selectOutputR.length + selectOutputIP.length }} {{$t('leftPaneOutPut.selected')}})</span
        > -->
            <span class="selectedNum"
              >({{
                selectOutputR.length +
                (mainDefaultGrid
                  ? isShowDefaultGrid
                    ? mediaInitParams.selectedOutput.length
                    : mediaInitParams.selectedOutput.length - 1
                  : mediaInitParams.selectedOutput.length)
              }}
              {{ $t("leftPaneOutPut.selected") }})</span
            >
            <!-- 唤醒创建grid的弹出窗 -->
            <span class="addGrid"  v-if="eventInfo.collaborateType != '2' && !(inputType === 'pgm' && productionRedundancy)">+</span>

            <div class="search" v-if="eventInfo.collaborateType != '2' && !(inputType === 'pgm' && productionRedundancy)">
              <el-input
                :placeholder="$t('eventList.search')"
                v-model="searchOutput"
                class="input-with-select"
                @keyup.enter.native="searchOutputFn"
              >
                <el-select
                  v-model="searchOutputType"
                  slot="prepend"
                  placeholder=""
                  popper-class="black"
                  :popper-append-to-body="false"
                >
                  <el-option
                    :label="$t('leftPaneOutPut.receiver')"
                    :value="1"
                  ></el-option>
                  <el-option
                    :label="$t('leftPaneOutPut.ipOut')"
                    :value="2"
                  ></el-option>
                </el-select>
                <i
                  slot="append"
                  class="el-icon-search"
                  @click="searchOutputFn"
                ></i>
              </el-input>
            </div>
            <!-- default grid -->
            <div
              class="grid clearfix"
              v-if="!mediaInitParams.selectedOutput.length"
            >
              <span
                class="name left overflow"
                :title="
                  mainDefaultGrid
                    ? mainDefaultGrid.pushLiveName
                    : ''
                "
              >
                {{
                  mainDefaultGrid
                    ? mainDefaultGrid.pushLiveName
                    : "Default Grid"
                }}
              </span>
              <span
                class="url left overflow"
                :title="
                  mainDefaultGrid ? mainDefaultGrid.pushLiveUrl : ''
                "
              >
                {{
                  mainDefaultGrid && isShowDefaultGrid
                    ? mainDefaultGrid.pushLiveUrl
                    : $t("otherWords.receiverMainPlay")
                }}
              </span>
              <el-popover
                placement="bottom-start"
                title=""
                popper-class="defaultInputOperate"
                width="150"
                trigger="click"
                ref="popoverGrid"
                v-model="visible"
              >
                <div
                  class="myBtn"
                  v-show="(eventInfo.status != 4 || !mainDefaultGrid )&& eventInfo.collaborateType != '2'"
                  @click="showGridSetting"
                >
                  {{ $t("otherWords.editSetting") }}
                </div>
                <div
                  class="myBtn"
                  v-show="eventInfo.status == 4 && mainDefaultGrid"
                >
                  <span
                    class="button"
                    v-if="
                      mainDefaultGrid
                        ? mainDefaultGrid.pushLiveUrl
                        : false
                    "
                    v-clipboard:copy="
                      copyLink(
                        mainDefaultGrid
                          ? mainDefaultGrid.pushLiveUrl
                          : ''
                      )
                    "
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                  >
                    {{ $t("eventList.copyLink") }}</span
                  >
                </div>
                <div
                  class="myBtn"
                  v-show="eventInfo.status == 4 && mainDefaultGrid && eventInfo.collaborateType != '2'"
                >
                  <div class="button" @click="showEditGridSetting">
                    {{ $t("otherWords.viewSetting") }}
                  </div>
                </div>
                <span class="operate right" slot="reference" v-show="!(inputType === 'pgm' && productionRedundancy)"
                  ><i class="el-icon-more"></i
                ></span>
              </el-popover>
            </div>
            <!-- pgm backup grid -->
            <div
              class="grid clearfix"
              v-if="inputType === 'pgm' && productionRedundancy && !mediaInitParams.selectedOutput.length"
            >
              <span
                class="name left overflow"
                :title="
                  backupDefaultGrid
                    ? backupDefaultGrid.pushLiveName
                    : ''
                "
              >
                {{
                  backupDefaultGrid
                    ? backupDefaultGrid.pushLiveName
                    : "Default Grid"
                }}
              </span>
              <span
                class="url left overflow"
                :title="
                  backupDefaultGrid ? backupDefaultGrid.pushLiveUrl : ''
                "
              >
                {{
                  backupDefaultGrid && isShowDefaultGrid
                    ? backupDefaultGrid.pushLiveUrl
                    : $t("otherWords.receiverBackUpPlay")
                }}
              </span>
              <el-popover
                placement="bottom-start"
                title=""
                popper-class="defaultInputOperate"
                width="150"
                trigger="click"
                ref="popoverBackupGrid"
                v-model="backupGridVisible"
              >
                <div
                  class="myBtn"
                  v-show="(eventInfo.status != 4 || !backupDefaultGrid )&& eventInfo.collaborateType != '2'"
                  @click="showGridSetting('backup')"
                >
                  {{ $t("otherWords.editSetting") }}
                </div>
                <div
                  class="myBtn"
                  v-show="eventInfo.status == 4 && backupDefaultGrid"
                >
                  <span
                    class="button"
                    v-if="
                      backupDefaultGrid
                        ? backupDefaultGrid.pushLiveUrl
                        : false
                    "
                    v-clipboard:copy="
                      copyLink(
                        backupDefaultGrid
                          ? backupDefaultGrid.pushLiveUrl
                          : ''
                      )
                    "
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                  >
                    {{ $t("eventList.copyLink") }}</span
                  >
                </div>
                <div
                  class="myBtn"
                  v-show="eventInfo.status == 4 && backupDefaultGrid && eventInfo.collaborateType != '2'"
                >
                  <div class="button" @click="showEditGridSetting('backup')">
                    {{ $t("otherWords.viewSetting") }}
                  </div>
                </div>
                <span class="operate right" slot="reference" v-show="!(inputType === 'pgm' && productionRedundancy)"
                  ><i class="el-icon-more"></i
                ></span>
              </el-popover>
            </div>
            <div class="outputList" v-if="info.id ? showDetail : true">
              <div
                class="pgmBackupOutputNote"
                v-if="inputType === 'pgm' && productionRedundancy"
              >
                {{ $t("otherWords.pgmBackupOutputNote") }}
              </div>
              <template v-if="!(inputType === 'pgm' && productionRedundancy)">
                <OutputList
                  ref="outPutList"
                  :info="info"
                  :request="receiverRequest"
                  title="Receiver"
                  :selectVal="selectOutputR"
                  @callback="outputCallback"
                  :rLiveIsspInfo="rLiveIsspInfo"
                  :eventInfo="eventInfo"
                  :searchType="searchOutputTypeLabel"
                  :disabled="isReuse ? false : info.type == 'reuse' ? true : false"
                  :cancelSelectedR="cancelSelectedR"
                  @changeReceiverSetting="changeReceiverSetting"
                  v-if="eventInfo.collaborateType != '2'"
                />
                <div v-else class="receiverOutput">
                  <span>{{eventInfo.receivers.length!=0 ? 'Receiver：':'Receiver：— —'}}</span>
                  <div class="receiverOutputList" v-for="item in eventInfo.receivers" :key="item.id">
                    <span>{{item.name}}</span>
                  </div>
                </div>
                <div class="mediaOutPutListTitle" v-if="eventInfo.collaborateType != '2'">
                  <span class="title" @click="changeCaret">
                    <i class="icon el-icon-caret-bottom" v-if="showCaret"></i>
                    <i class="icon el-icon-caret-right" v-else></i>
                    <span>{{ $t("leftPaneOutPut.ipOut") }}</span>
                  </span>
                  <div id="mediaOutputList" class="scrollbar"></div>
                </div>
                <div v-else class="ipOutOutput">
                  <span>{{eventInfo.templates.length!=0 ? 'IP OUT：' : 'IP OUT：— —'}}</span>
                  <div class="ipOutOutputList"  v-for="item in eventInfo.templates" :key="item.id">
                    <span v-if="item.name!='Default Grid'">{{item.name}}</span>
                    <span v-else>— —</span>
                  </div>
                </div>
              </template>
              <ReceiverSetting
                v-if="receiverSetting.show"
                :info="receiverSetting"
                @closePopup="closeReceiverSetting"
                @setIsspUrl="controlLiveIssp"
                :eventInfo="eventInfo"
                :rLiveIsspInfo="rLiveIsspInfo"
              ></ReceiverSetting>
            </div>
          </div>
          <el-divider></el-divider>
          <div class="otherSetting">
            <!-- output format 区域 -->
            <div class="title outputFormat" v-show="receiverType != '1'">
              <span class="label">{{ $t("eventList.outputFormat") }}</span>
              <el-select
                v-model="producerSettingsDto.format"
                placeholder="Select Output Format"
                popper-class="black"
                :disabled="
                componentDisabled || (eventInfo.status == 4 || eventInfo.status == 2 ? true : false)
                "
                class="formatOutput"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="(value, index) in formats"
                  :key="index"
                  :label="value"
                  :value="value"
                >
                </el-option>
              </el-select>
            </div>
            <!-- remark 区域 -->
            <div class="title remark">
              <span class="label">{{ $t("eventList.remark") }}</span>
              <el-input
                v-model="description"
                type="textarea"
                :autosize="{ minRows: 1, maxRows: 5 }"
                :placeholder="$t('eventList.addDescription')"
                :disabled="eventInfo.collaborateType == '2'"
              ></el-input>
            </div>
            <!-- more advance 区域 -->
            <div class="title advanced">
              <span class="label">{{ $t("eventList.advanced") }}</span>
              <a class="myBtn" @click="showAdvanced" :class="{ 'disabled': componentDisabled }" href="javascript:void(0);">{{
                $t("eventList.advancedSettings")
              }}</a>
            </div>
            <!--添加co-host--->
            <div class="title addCoHost">
              <div>
                <span class="label">{{ $t("coHost.coHostTitle") }}</span>
                <a
                  class="myBtn"
                  @click="coHostAssign"
                  href="javascript:void(0);"
                  >{{
                    eventInfo.collaborateType != "2"
                      ? $t("coHost.coHostAssign")
                      : $t("coHost.quit")
                  }}</a
                >
              </div>
              <div class="invitedContent">
                <div class="supportNumber">{{ $t("coHost.supportNumber", {supportNumber:State.config.coHostInfo.limit}) }}</div>
                <div style="display: inline-block;" v-for="(item, index) in State.assignCoHostEmails"
                :key="index">
                  <span
                    class="invitedPerson"
                    :style="{'backgroundColor':item.color}"
                  >
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="State.assignEmailNames[index]"
                      placement="top"
                    >
                      <span> {{ item.email }}</span>
                    </el-tooltip>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <el-divider></el-divider>
          <!-- 添加 group 区域 -->
          <div class="title groups">
            <div>
              <span class="label"
                ><i class="require">*</i>{{ $t("eventList.group") }}</span
              >
              <a
                class="myBtn"
                @click="addGroup"
                href="javascript:void(0);"
                v-if="
                 eventInfo.collaborateType != 2 && partyList.length < Config.eventMaxParty &&
                  (info.type != 'reuse' || isReuse)
                "
                >{{ $t("eventList.addNew") }}</a
              >
            </div>
            <div class="pointer inviteBox" v-if="info.type != 'creat'">
              <span class="f_15" @click="showInvite()">{{
                invitedInfo | showJoinModel
              }}</span
              ><i class="el-icon-arrow-down"></i>
            </div>
          </div>
          <!-- 添加 group 区域 -->
          <div class="title addGroup">
            <div class="groupItem" v-for="(val, key) in partyList" :key="key">
              <span class="index">No.{{ key + 1 }}</span>
              <el-input
                v-model="val.title"
                :placeholder="$t('eventList.addGroupName')"
                :maxlength="64"
                :disabled="isReuse ? false : info.type == 'reuse' ? true : false"
              ></el-input>
              <i
                class="el-icon-delete"
                @click="deleteFn(key)"
                v-if="info.type != 'reuse' || isReuse"
              ></i>
              <el-divider
                direction="vertical"
                v-if="val.partyCode && (info.type != 'reuse' || isReuse)"
              ></el-divider>
              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('eventList.copyGroupLink')"
                placement="top"
              >
                <span
                  class="link el-icon-connection"
                  v-if="val.partyCode && (eventInfo.status <= 4 || isReuse)"
                  v-clipboard:copy="copyLink(val, 'partyCode')"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                ></span>
              </el-tooltip>
            </div>
          </div>
        </div>
        <!-- 显示 group link 的区域 -->
        <div class="content groupLink" v-if="showGroupLink">
          <div class="title addGroup">
            <div class="groupItem" v-for="(val, key) in partyList" :key="key">
              <div v-if="val.title">
                <span class="index">No.{{ key + 1 }}</span>
                <el-tooltip
                  class="item"
                  effect="dark"
                  placement="top-start"
                  :visible-arrow="false"
                >
                  <el-input
                    v-model="val.title"
                    :placeholder="$t('eventList.addGroupName')"
                    :maxlength="64"
                    :readonly="true"
                  ></el-input>
                  <div slot="content">
                    {{ $t("otherWords.partyId") }}:{{ val.partyCode }}
                  </div>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('eventList.copyGroupLink')"
                  placement="top"
                >
                  <span
                    class="link el-icon-connection"
                    v-clipboard:copy="copyLink(val, 'partyCode')"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                  ></span>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
        <!-- 弹框底部按钮区域 -->
        <span slot="footer" class="dialog-footer">
          <div
            class="pointer inviteBox left"
            v-if="showGroupLink"
            @click="inviteInfo.show = true"
          >
            <span class="f_15">{{ invitedInfo | showJoinModel }}</span
            ><i class="el-icon-arrow-down"></i>
          </div>
          <el-button
            class="disabled"
            disabled
            v-if="eventReuse"
          >
            {{ $t("leftPane.cancel") }}
          </el-button>
          <a
            href="javascript:void(0);"
            class="cancel"
            v-else-if="!showGroupLink"
            @click="done"
            >{{ $t("leftPane.cancel") }}</a
          >
          <el-button
            class="disabled"
            disabled
            v-if="eventReuse"
          >
            {{ $t("leftPaneOutPut.save") }}
          </el-button>
          <el-button
            v-if="!showGroupLink && (info.type != 'reuse' || isReuse)"
            class="save"
            :loading="createLoading"
            @click="save"
            v-repeatClick
            >{{ $t("leftPaneOutPut.save") }}</el-button
          >
          <a
            href="javascript:void(0);"
            class="save"
            v-if="showGroupLink"
            @click="done"
          >
            {{ $t("eventList.doneN") }}
          </a>
        </span>
        <CreateFailed
          v-if="createFailedInfo.show"
          :info="createFailedInfo"
        ></CreateFailed>
        <OutputSetting
          v-if="viewSetting.type === 'G' && viewSetting.show"
          @closeDialog="closeGridSettingDialog"
          :gridInfo="showCreateDialog ? basicSetting : viewSetting"
        ></OutputSetting>
        <ReceiverConflict
          v-if="receiverConflictInfo.show"
          :info="receiverConflictInfo"
          :receiverConflictErrorCode="receiverConflictErrorCode"
          @hideCheckedReceiver="hideCheckedReceiver"
        ></ReceiverConflict>
        <SourceConflict
          v-if="sourceConflictInfo.show"
          :info="sourceConflictInfo"
        ></SourceConflict>
      </el-dialog>
    </div>
    <AdvancedSettings
      ref="advanceSetting"
      :receiverType="receiverType"
      :showDone="showDone"
      :backupReceiverPeerId="backupReceiverPeerId"
      :receiverBackupBtnVal="receiverBackupBtnVal"
      :advanceSettings="advanceSettings"
      :eventInfo="eventInfo"
      :qualityFeature="qualityFeature"
      v-if="advancedSettingsInfo.show"
      :eventTypeInfo="info"
      :info="advancedSettingsInfo"
      @changeConfig="changeConfig"
      @showFoot="showFoot"
    >
    </AdvancedSettings>
    <RtmpPush
      v-if="rtmpPushInfo.show"
      :rtmpBackType="rtmpBackType"
      :changeRtmpType="changeRtmpType"
      :eventInfo="eventInfo"
      :eventTypeInfo="info"
      :info="rtmpPushInfo"
      @showFootRtmp="showFoot"
    />
    <RtmpPushBackUp
      v-if="rtmpPushInfoBackup.show"
      :rtmpBackType="rtmpBackType"
      :changeRtmpType="changeRtmpType"
      :eventInfo="eventInfo"
      :eventTypeInfo="info"
      :info="rtmpPushInfoBackup"
      @showFootRtmpBackup="showFoot"
    />
    <Invited
      :partyCode="eventInfo.partyCode || invitedInfo.partyCode"
      :inviteInfo="inviteInfo"
      :invitedInfo="invitedInfo"
      @callback="dealInviteEvent"
    />
    <QuitCoHost
      :info="quitCoHostInfo"
      @quitCoHost ="quitCoHost"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import SelectScroll from '@/components/selectScroll'
import utils from '@/assets/js/utils'
import CreateFailed from './createEventFailed'
import SelectScrollFile from './selectScrollFile'
import SelectMenu from '@/components/selectMenu'
import OutputList from './outputList'
import OutputSetting from '../dialog/outputSetting'
import ReceiverSetting from '../dialog/receiverSetting.vue'
import i18n from '@/lang/index.js'
import Bus from '@/assets/js/bus.js'
import ReceiverConflict from './recieverConflict.vue'
import SourceConflict from './sourceConflictInfo.vue'
import AdvancedSettings from './advancedSettings.vue'
import RtmpPush from './rtmpPush.vue'
import QuitCoHost from './quitCoHost.vue'
import RtmpPushBackUp from './rtmpPushBackup.vue'
import checkRFeature from '@/components/common/checkRFeature.vue'
import Invited from '@/components/common/invited.vue'
export default {
  components: {
    SelectScroll,
    CreateFailed,
    SelectScrollFile,
    SelectMenu,
    OutputList,
    OutputSetting,
    ReceiverSetting,
    ReceiverConflict,
    SourceConflict,
    AdvancedSettings,
    RtmpPush,
    RtmpPushBackUp,
    checkRFeature,
    Invited,
    QuitCoHost
  },
  props: {
    selectInput: {
      type: Object,
      default: () => {
        return {}
      }
    },
    selectedAssignEmails: {
      type: Array,
      default: () => {
        return []
      }
    },
    selectOutput: {
      type: Array,
      default: () => {
        return []
      }
    },
    info: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      coHost: {
        collaborateUserEmailList: []
      },
      isDualPgm: false,
      qualityFeature: true,
      loading: false,
      backupLoading: false,
      rtmpBackType: '',
      backType: 'backup',
      pgmBackInputText: 'PP PGM',
      changeRtmpType: '',
      showDone: false,
      domain: '',
      advanceSettings: {},
      formats: [],
      inputSourcesRecord: '',
      showAdvanceds: true,
      scrollS: {
        loading: false
      },
      scrolNumber: '',
      visible: false,
      backupGridVisible: false,
      rList: [],
      backupRList: [],
      coordinationUrl: `${window.location.protocol}//${document.domain}/commentator/coordination?id=${this.info.id}`,
      disabledMessage: '',
      disabledBackMessage: '',
      disabledBackInputSlotMessage: '',
      disabledInputSlotMessage: '',
      disableInputSlot: [],
      disableBackInputSlot: [],
      isReuse: false,
      searchOutputTypeLabel: 'Receiver',
      searchOutputType: 1,
      searchOutput: '',
      receiverSetting: {
        show: false
      },
      producerSettingsDto: {
        replayApp: 0,
        pgmRecording: 1,
        partyLine: 0,
        rps: 0,
        outputDelayTime: 0,
        outputDelay: 0,
        delay: 2,
        platform: '1',
        region: '',
        zone: '',
        format: '1080I5994',
        elasticIp: '',
        inputSourcesRecord: '',
        audioChannelNum: '8'
      },
      inputPreviewSetting: {
        bitrate: '2000K',
        resolution: '1280x720',
        frameRate: '30',
        enableVbr: false
      },
      finalPgmPreviewSetting: {
        bitrate: '2000K',
        resolution: '1280x720',
        frameRate: '30',
        enableVbr: false
      },
      advancedSetting: {
        quality: '360p'
      },
      viewSetting: {
        show: false,
        id: '',
        type: '',
        auth: '',
        origin: 'producer'
      },
      specialRList: ['CA=4000'],
      backupTypeList: [],
      backupType: 'vfb',
      purpose: 1,
      backupBtnVal: false,
      productionRedundancy: false,
      receiverBackupBtnVal: false,
      inputType: 'vfb',
      selectOutputR: [],
      selectOutputIP: [],
      selectInputRecord: {},
      selectBackupRecord: {},
      startDatePickerOptions: {
        disabledDate: (time) => {
          const nowDate = utils.formatTimeStartEnd(new Date().getTime(), true)
          // time当前日期的零点返回，但是now按钮返回的是当前时间，统一按0点时间去比较
          time = utils.formatTimeStartEnd(new Date(time).getTime(), true)
          const endTime = utils.formatTimeStartEnd(this.endTime, true)
          return (endTime && time > endTime) || time < nowDate
        }
      },
      endDatePickerOptions: {
        disabledDate: (time) => {
          const nowDate = utils.formatTimeStartEnd(new Date().getTime(), true)
          const startTime = utils.formatTimeStartEnd(this.startTime, true)
          // time当前日期的零点返回，但是now按钮返回的是当前时间，统一按0点时间去比较
          time = utils.formatTimeStartEnd(new Date(time).getTime(), true)
          return (startTime && time < startTime) || time < nowDate
        }
      },
      createFailedInfo: {
        show: false
      },
      durationTime: [
        {
          time: 30,
          unit: 'min'
        }, {
          time: 1,
          unit: 'hour'
        }, {
          time: 2,
          unit: 'hour'
        }, {
          time: 3,
          unit: 'hour'
        }
      ],
      duration: 30,
      durationType: {
        time: 30,
        unit: 'min'
      },
      isStartNow: false,
      isEndNow: false,
      dialogTitle: 'Create an event',
      showGroupLink: false,
      show: true,
      title: '',
      time: [],
      startTime: '',
      endTime: '',
      timeControl: true,
      sourceType: this.type == 'file' ? 2 : 1,
      regionList: [],
      providerList: [],
      zoneList: [],
      zoneLoading: false,
      backupZoneList: [],
      backupZoneLoading: false,
      description: '',
      audioMixer: '',
      partyList: [],
      eventInfo: {},
      rLiveIsspInfo: {},
      fileInfo: {
        id: this.selectInput.type == 'file' ? this.selectInput.id : '',
        name: '',
        region: ''
      },
      backupFileInfo: {},
      requestSource: {
        rtmp: {
          url: '/commentator-backend/receiver/rtmp',
          params: {}
        },
        sdi: {
          url: '/commentator-backend/receiver/getLocalSDI',
          params: {}
        },
        ext: {
          url: '/commentator-backend/receiver/getExt',
          params: {}
        },
        slot: {
          url: '/commentator-backend/production/slots',
          params: {}
        },
        pp: {
          url: '/commentator-backend/user/source/input/pp/page',
          params: {
            pageNum: 1,
            pageSize: 20,
            sourceType: null
          },
          name: '',
          label: 'sourceName',
          value: 'id'
        },
        cc: {
          name: '',
          url: '/commentator-backend/user/source/output/receiver/page',
          params: {
            condition: '',
            living: true,
            noCamera: true,
            offline: true,
            online: true,
            pack: true,
            pageNum: 1,
            pageSize: 20
          }
        },
        vfb: {
          url: '/commentator-backend/device/pageDevice',
          params: {
            pageNum: 1,
            pageSize: 20,
            condition: '',
            living: true,
            online: true,
            offline: true,
            noCamera: true,
            gridSdi: true,
            gridPack: true
          },
          name: ''
        }
      },
      sourceTypePamrs: {
        vfb: {
          label: 'TVU Transceiver - Grid',
          value: ''
        },
        file: {
          label: 'Upload files',
          value: ''
        },
        pgm: {
          label: 'PP PGM',
          value: ''
        },
        slot: {
          label: 'PP slot',
          value: ''
        },
        ext: {
          label: 'EXT IP Source',
          value: 2
        },
        pack: {
          label: 'Pack',
          value: 4
        },
        anywhere: {
          label: 'Anywhere',
          value: 6
        },
        grid: {
          label: 'Grid',
          value: 5
        }
      },
      requestInfo: {},
      requestBackupInfo: {},
      backupRequestInfo: {},
      receiverRequest: {
        url: '/commentator-backend/user/source/output/receiver/page',
        params: {
          pageNum: 1,
          pageSize: 20,
          condition: '',
          living: true,
          online: true,
          offline: true,
          noCamera: true,
          receiver: true
        }
      },
      ipOutRequest: {
        url: `/commentator-backend/user/source/output/ipOut/list/${this.info.id}`,
        id: 'id'
      },
      ipOutTemplate: {
        url: '/commentator-backend/output/template/page',
        id: 'id',
        params: {
          pageNum: 1,
          pageSize: 20,
          name: ''
        }
      },
      showDetail: false,
      inputTypeList: [],
      showEditIpout: true,
      showCreateDialog: false,
      basicSetting: {
        auth: 'edit',
        id: '',
        type: 'G'
      },
      receiverConflictErrorCode: '',
      receiverConflictInfo: {
        show: false,
        info: {}
      },
      advancedSettingsInfo: {
        show: false,
        info: {}
      },
      rtmpPushInfo: {
        show: false,
        info: {}
      },
      rtmpPushInfoBackup: {
        show: false,
        info: {}
      },
      sourceConflictInfo: {
        show: false,
        info: {}
      },
      cancelSelectedR: [],
      showCaret: true,
      isShowElasticIP: false,
      isShowBackupElasticIP: false,
      backupRegion: '',
      backupZone: '',
      backupElasticIp: '',
      elasticIpList: [],
      hasElasticIp: false,
      editElasticIP: false,
      isUnbind: false,
      selectIsspId: '',
      createLoading: false,
      // inputBitrate: 2,
      receiverPeerId: '',
      backupReceiverPeerId: '',
      receiverOutputName: '',
      backupReceiverOutputName: '',
      receiverType: 0,
      receiverInputType: '',
      backupReceiverInputType: 'sdi',
      rTypeList: [
        {
          val: 0,
          label: 'cloudReceiver'
        },
        {
          val: 1,
          label: 'tvuTransceiver'
        }
      ],
      typeList: [
        {
          label: 'SDI IN',
          val: 'sdi'
        },
        {
          label: 'EXT IP',
          val: 'ext'
        }
      ],
      backUpInTypeList: [
        {
          label: 'SDI IN',
          val: 'sdi'
        },
        {
          label: 'EXT IP',
          val: 'ext'
        }
      ],
      scroll: {
        onScroll: this.getReceiverList,
        loading: true,
        noMore: false,
        directive: '.el-select-dropdown__wrap'
      },
      backupScroll: {
        onScroll: this.getBackupReceiverList,
        loading: true,
        noMore: false,
        directive: '.el-select-dropdown__wrap'
      },
      getRListParams: {
        pageNum: 1,
        pageSize: 100,
        condition: '',
        living: true,
        online: true,
        offline: true,
        noCamera: true,
        receiver: true,
        version: 7.8,
        versionCompare: 1
      },
      getBackupRListParams: {
        pageNum: 1,
        pageSize: 100,
        condition: '',
        living: true,
        online: true,
        offline: true,
        noCamera: true,
        receiver: true,
        version: 7.8,
        versionCompare: 1
      },
      getRListTimer: null,
      getBackupRListTimer: null,
      eventRid: '',
      defaultGridText: 'Default Grid',
      quitCoHostInfo: {
        show: false,
        title: this.$t('coHost.quitTitle'),
        contentText: this.$t('coHost.quitTips'),
        confirmText: false
      },
      inviteInfo: {
        show: false,
        title: 'invite.getLink',
        save: 'invite.saveInvite',
        hideCancel: true,
        hideSave: true
      },
      invitedInfo: {},
      userFeature: {}
    }
  },
  watch: {
    eventReuse: {
      handler: function (val) {
        this.$nextTick(() => {
          const dialogHeader = this.$refs.eventDialog.$el.querySelector('.el-dialog__header')
          if (val) {
            dialogHeader.style.background = '#03897B'
          } else {
            dialogHeader.style.background = 'none'
          }
        })
      },
      immediate: true
    },
    selectedAssignEmails (newVal) {
      this.eventInfo.coHost = {
        collaborateUserEmailList: []
      }
      this.coHost.collaborateUserEmailList = newVal
      this.eventInfo.coHost.collaborateUserEmailList = this.coHost.collaborateUserEmailList
    },
    scrolNumber: {
      handler (newName, oldName) {
        if (newName != oldName) {
          this.visible = false;
        }
      }
    },
    inputType: {
      handler: function (val) {
        if (val === 'file') {
          this.$set(this.disableBackInputSlot, '0', 's5')
          this.disabledBackInputSlotMessage = this.$t('otherWords.fileAndSlotOnlyOne')
        } else if (val === 'slot' && this.selectInputRecord.slot) {
          this.$set(this.disableBackInputSlot, '0', this.selectInputRecord.slot.id)
          this.disabledBackInputSlotMessage = ''
        } else {
          this.disableBackInputSlot = []
          this.disabledBackInputSlotMessage = ''
        }
        this.backupTypeList.forEach((v) => {
          v.options.forEach((vals, index) => {
            this.$set(v.options, index, { ...vals, disabled: false })
            if (vals.value == val && val == 'file') {
              this.$set(v.options, index, { ...vals, disabled: true })
            }
            if (vals.value == val && val == 'pgm') {
              this.$set(v.options, index, { ...vals, disabled: true })
            }
            // 用户在输入源中切换至其他源，然后再切回至slot5时，禁用掉备用输入的上传文件
            if (val === 'slot' && this.selectInputRecord.slot && this.selectInputRecord.slot.id === 's5' && vals.value === 'file') {
              this.$set(v.options, index, { ...vals, disabled: true })
            }
          })
        })
      },
      immediate: true
    },
    backupType: {
      handler: function (val) {
        // 用户在备用输入中选择了上传文件，禁用掉输入源中的slot5
        if (val === 'file') {
          this.$set(this.disableInputSlot, '0', 's5')
          this.disabledInputSlotMessage = this.$t('otherWords.fileAndSlotOnlyOne')
        } else if (val === 'slot' && this.selectBackupRecord.slot) {
          this.$set(this.disableInputSlot, '0', this.selectBackupRecord.slot.id)
          this.disabledInputSlotMessage = ''
        } else {
          this.disableInputSlot = []
          this.disabledInputSlotMessage = ''
        }
        this.inputTypeList.forEach((v) => {
          v.options.forEach((vals, index) => {
            this.$set(v.options, index, { ...vals, disabled: false })
            // 用户在备用输入中选择了上传文件，禁用掉输入源中的上传文件
            if (vals.value == val && val == 'file') {
              this.$set(v.options, index, { ...vals, disabled: true })
            }
            if (vals.value == val && val == 'pgm') {
              this.$set(v.options, index, { ...vals, disabled: true })
            }
            // 用户在备用输入源中切换至其他源，然后再切回至slot5时，禁用掉输入源中的上传文件
            if (val === 'slot' && this.selectBackupRecord.slot && this.selectBackupRecord.slot.id === 's5' && vals.value === 'file') {
              this.$set(v.options, index, { ...vals, disabled: true })
            }
          })
        })
      },
      immediate: true
    }
  },
  computed: {
    ...mapState({
      State: (state) => state,
      Config: (state) => state.config,
      initInputTypeList: (state) => state.sourceType,
      mediaInitParams: (state) => state.mediaInitParams
    }),
    componentDisabled () {
      return (this.isReuse ? false : this.info.type == 'reuse') || (this.eventInfo.collaborateType == '2')
    },
    eventReuse () {
      return !this.showGroupLink && this.info.type == 'reuse' && !this.isReuse
    },
    mainDefaultGrid () {
      const list = this.eventInfo.defaultGrid
      if (Array.isArray(list)) {
        return list.find(item => item.purpose === 1) || null
      }
      return list || null
    },
    backupDefaultGrid () {
      const list = this.eventInfo.defaultGrid
      if (Array.isArray(list)) {
        return list.find(item => item.purpose === 2) || null
      }
      return null
    },
    isShowDefaultGrid () {
      let showDefaultGrid = true
      const outputs = this.$store.state.mediaInitParams.selectedOutput
      // 有ipout两个以上其中，包含一个Default Grid
      if ((outputs.some(value => value.name === 'Default Grid') && this.$store.state.mediaInitParams.selectedOutput.length != 1)) {
        showDefaultGrid = false
      }
      return showDefaultGrid
    },
    showActiveBackground () {
      let showBg = false
      if (this.receiverType == 1) {
        if (this.purpose == 1 && this.receiverBackupBtnVal) {
          showBg = true
        }
      } else {
        if (this.purpose == 1 && this.backupBtnVal) {
          showBg = true
        }
        if (this.inputType == 'pgm') {
          showBg = false
        }
      }
      return showBg
    },
    showSwitchInput () {
      return (this.receiverBackupBtnVal || this.backupBtnVal) && this.inputType != 'pgm'
    },
    activeApply () {
      return this.eventInfo.mainWindowType != this.purpose
    }
  },
  filters: {
    showJoinModel (info) {
      const value = info.inviteMode
      if (value === 0) {
        return i18n.t('invite.anyoneJoin')
      } else if (value === 1) {
        return i18n.t('invite.onlyUserJoin')
      } else if (value === 3) {
        return i18n.t('invite.onlyByPasscode')
      } else {
        return i18n.t('invite.anyoneJoin')
      }
    },
    showRegion (name) {
      if (!name) return ''
      if (name === 'Asia Pacific (Seoul)') {
        return i18n.t('eventRegions.seoul')
      } else if (name === 'Asia Pacific (Mumbai)') {
        return i18n.t('eventRegions.mumbai')
      } else if (name === 'South America (São Paulo)' || name === 'South America (SÃ£o Paulo)') {
        return i18n.t('eventRegions.paulo')
      } else if (name === 'Europe (Paris)') {
        return i18n.t('eventRegions.parise')
      } else if (name === 'Europe (Frankfurt)') {
        return i18n.t('eventRegions.frankfurt')
      } else if (name === 'Asia Pacific (Tokyo)') {
        return i18n.t('eventRegions.tokyo')
      } else if (name === 'US East (N. Virginia)') {
        return i18n.t('eventRegions.virginia')
      } else if (name === 'Asia Pacific (Sydney)') {
        return i18n.t('eventRegions.sydney')
      } else if (name === 'US West (Oregon)') {
        return i18n.t('eventRegions.oregon')
      } else if (name === 'Middle East (Bahrain)') {
        return i18n.t('eventRegions.bahrain')
      } else {
        return name
      }
    },
    showTimeUnit (unit) {
      if (!unit) return ''
      if (unit === 'min') {
        return i18n.t('otherWords.min')
      } else if (unit === 'hour') {
        return i18n.t('otherWords.hour')
      } else {
        return unit
      }
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll, true)
  },
  async created () {
    this.inputTypeList = JSON.parse(JSON.stringify(this.initInputTypeList))
    // 获取当前本地所在ip
    this.producerSettingsDto.region = localStorage.getItem('region')
      ? localStorage.getItem('region')
      : ''
    this.backupRegion = this.producerSettingsDto.region
    const backupList = JSON.parse(JSON.stringify(this.inputTypeList))
    this.backupTypeList = backupList && backupList.map(v => {
      const item = v.options.filter(val => {
        return val.value != 'pgm'
      })
      return {
        ...v, options: item
      }
    })
    if (this.info.id) {
      await this.getEventInfo()
    } else {
      // 设置初始值（暂时设置，后续等后台接口进行定义字段）
      this.inputType = this.selectInput.type
      this.selectInputRecord[this.inputType] = {
        id: this.selectInput.id,
        name: this.selectInput.name
      }
      this.addHostAndPipEmail()
      this.getRequest('input')
      this.requestInfo.name = this.selectInput.name
      this.backupRequestInfo.name = this.selectInput.name
      this.getRequest('backup')
      this.selectOutput.forEach((v) => {
        if (v.type == 'Receiver' && v.items) {
          this.selectOutputR = v.items.map((val) => {
            return { id: val.peerId, name: val.name }
          })
        }
        if (v.type == 'IPout' && v.items) {
          this.selectOutputIP = v.items.map((val) => {
            const { id, name, type } = val
            return { id, name, type }
          })
        }
      })
    }
    // 云R事件需要获取zoneList和reagionList
    if (this.receiverType != 1) {
      // AdvancedSettings Feature
      this.getAdvanceSetting()
      // 是否需要zoneControl
      await this.getUserFeature()
      // 获取云提供者列表
      await this.getProviderList()
      // 获取regionList
      await this.getRegionList()
    }
    // 显示对话框标题
    if (this.info.type === 'reuse') {
      this.dialogTitle = this.$t('eventList.createEvent')
    } else if (this.info.type === 'edit') {
      this.dialogTitle = this.$t('eventList.editEvent')
    } else {
      this.dialogTitle = this.$t('eventList.createEvent')
    }
    Bus.$on('eventInfoUpdate', (data) => {
      if (data.clientId != this.State.clientId) {
        const { id } = data
        // 在此更新用户在coordinationRoom的编辑事件
        this.getEventInfo(id)
      }
    })
    if (!this.info.id) {
      this.getMediaOutPutList()
    }
    Bus.$emit('changeToReceiver')
    if (this.info.type == 'creat') {
      this.getElasticIp()
    }
    this.getQualityFeature()
    this.getRArray('init')
    this.getBackupRArray('init')
  },
  methods: {
    addHostAndPipEmail () {
      this.State.assignEmailNames = []
      this.State.assignCoHostEmails = []
      if (!this.eventInfo.id) {
        const emailList = []
        emailList.push(this.State.loginInfo.email)
        // 如果需要继续处理emailList，比如获取每个邮件的首字母形成新的数组
        this.State.assignCoHostEmails = emailList.map(email => {
          const namePart = email.split('@')[0]
          this.State.assignEmailNames.push(namePart + ' (owner)')
          const color = email === this.State.loginInfo.email ? this.State.avatarColor : utils.getEmailColor(email, this.State.avatarColor);
          return { email: email.slice(0, 1), color: color }
        })
        return
      }
      this.$http
        .get(`/commentator-backend/collaborate/queryEventUser?eventId=${this.eventInfo.id}`)
        .then(res => {
          const { errorCode, result } = res.data
          if (errorCode === '0x0') {
            this.eventInfo = {
              ...this.eventInfo,
              coHost: {
                collaborateUserEmailList: result.collaborateUserEmailList
              },
              hostEmail: result.hostEmail
            }
            // 首先只处理 collaboratorUserEmailList 中的前四个邮件
            const emailList = this.eventInfo.coHost.collaborateUserEmailList ? this.eventInfo.coHost.collaborateUserEmailList.slice(0, 3) : []
            // 确保emailList为数组，然后添加this.State.loginInfo.email到数组末尾
            emailList.push(this.eventInfo.hostEmail || this.State.loginInfo.email)
            // 如果需要继续处理emailList，比如获取每个邮件的首字母形成新的数组
            this.State.assignCoHostEmails = emailList.map(email => {
              const namePart = email.split('@')[0]
              const isOwner = email === this.eventInfo.hostEmail || (email === this.State.loginInfo.email && this.eventInfo.collaborateType != 2)
              this.State.assignEmailNames.push(isOwner ? namePart + ' (owner)' : namePart)
              const color = email === this.State.loginInfo.email ? this.State.avatarColor : utils.getEmailColor(email, this.State.avatarColor);
              return {
                email: email.slice(0, 1),
                color: color
              }
            })
          }
        })
    },
    coHostAssign () {
      if (this.eventInfo.id && this.eventInfo.collaborateType != '2') {
        // 事件已经创建且非cohost，直接调用assign接口
        this.$emit('openAssignCohost', this.eventInfo)
      } else if (this.eventInfo.id && this.eventInfo.collaborateType == '2') {
        // cohost 退出角色
        this.quitCoHostInfo.show = true
      } else if (!this.eventInfo.id) {
        // 事件未创建为cohost
        this.$emit('openAssignCohost', '')
      }
    },
    quitCoHost () {
      const params = {
        userId: this.State.loginInfo.id,
        eventId: this.eventInfo.id
      }
      this.$http
        .post('/commentator-backend/collaborate/cancel', params)
        .then(res => {
          const { errorCode } = res.data
          if (errorCode === '0x0') {
            this.$message.success(this.$t('coHost.cancelCoHost'))
            this.$emit('closeDialog')
          }
        })
    },
    getQualityFeature () {
      this.$http.get('/commentator-backend/userSetting/findByKey/quality')
        .then(res => {
          if (res.data.errorCode === '0x0') {
            this.qualityFeature = res.data.result === 'true'
          }
        }).catch(error => {
          console.log(error)
        })
    },
    dealInviteEvent (info) {
      const { type, val } = info
      if (type === 'changeModel') {
        this.invitedInfo.inviteMode = val
      }
    },
    async dealReceiverTypeList (ext, type) {
      if (!ext) return
      let isSpecial = false
      let list = (type === 'main' ? this.typeList : this.backUpInTypeList).slice()
      this.specialRList.forEach(key => {
        if (ext.includes(key)) {
          isSpecial = true
          list = list.filter(item => item.val !== 'sdi')
          list.unshift({
            label: '2110',
            val: 'sdi'
          })
        }
      })
      if (!isSpecial) {
        const isHaveSdi = list.some(item => item.label === 'SDI IN')
        list = list.filter(item => item.label !== '2110')
        !isHaveSdi && list.unshift({
          label: 'SDI IN',
          val: 'sdi'
        })
      }
      if (type === 'main') {
        this.typeList = list
      } else {
        this.backUpInTypeList = list
      }
    },
    async clickBackupReceiverPeerId (item) {
      if (this.receiverPeerId === item.peerId) {
        this.$message.error(`${item.name} ` + this.$t('otherWords.onlySelectedOnce'))
      }
      await this.dealReceiverTypeList(item.ext, 'backup')
    },
    async clickReceiverPeerId (item) {
      if (this.backupReceiverPeerId === item.peerId && this.receiverBackupBtnVal) {
        this.$message.error(`${item.name} ` + this.$t('otherWords.onlySelectedOnce'))
      }
      await this.dealReceiverTypeList(item.ext, 'main')
    },
    async getSpecialR (peerId) {
      const params = {
        rid: peerId
      }
      return await this.$http
        .post(`/commentator-backend/receiver/getRivermaxConfig?rid=${peerId}`, params)
        .then(res => {
          if (res.data.errorCode === '0x0') {
            const result = JSON.parse(res.data.result)
            return !result.errorCode
          } else {
            return false
          }
        })
        .catch(error => {
          console.log(error)
          return false
        })
    },
    // 用户feature 读取 例如ZoneControl
    async getUserFeature () {
      const params = {
        userId: this.State.loginInfo.id
      }
      await this.$http.post(`https://${this.State.config.urlInfo.gateway}/newppapi/user/getFeatures`, params)
        .then(res => {
          if (res.data.errorCode === '0x0') {
            this.userFeature = res.data.result
          }
        }).catch(error => {
          console.log(error)
        })
    },
    // 高级设置feature 读取
    getAdvanceSetting () {
      this.$http.get(`https://${this.State.config.urlInfo.gateway}/newppapi/user/available-features`)
        .then(res => {
          if (res.data.errorCode === '0x0') {
            this.advanceSettings = res.data.result
            this.formats = res.data.result.format.options
          }
        }).catch(error => {
          console.log(error)
        })
    },
    showFoot (obj, type) {
      this.showAdvanceds = true
      if (type == 'rtmp') {
        this.$set(this.selectInputRecord, this.inputType, obj)
      } else if (type == 'rtmpBackUp') {
        this.$set(this.selectBackupRecord, this.backupType, obj)
      } else if (type == 'advancedSettings') {
        if (this.eventReuse) {
          this.$nextTick(() => {
            const dialogHeader = this.$refs.eventDialog.$el.querySelector('.el-dialog__header')
            dialogHeader.style.background = '#03897B'
          })
        }
        // 获取checkfeature相关状态
        this.getFeatureInfo()
      }
      // 重新加载media对应的ipout组件
      this.getMediaOutPutList()
    },
    changeConfig (obj) {
      this.producerSettingsDto.rps = obj.checkedRps
      this.producerSettingsDto.pgmRecording = obj.checkedPgmRecording
      this.producerSettingsDto.partyLine = obj.checkedPartyline
      this.producerSettingsDto.replayApp = obj.checkedReplayApp
      this.producerSettingsDto.outputDelayTime = obj.outPutBufferValue
      this.producerSettingsDto.outputDelay = obj.checkedOutPutBuffer
      this.producerSettingsDto.cloudRecord = obj.checkedInputSourceRecording
      this.producerSettingsDto.recordSources = obj.cloudRecordChecked.toString()
      this.producerSettingsDto.delay = obj.bitrateValue
      this.producerSettingsDto.audioChannelNum = obj.audioChannelNum
      // 比特率，码率，分辨率
      this.inputPreviewSetting.bitrate = obj.mainWindowBitrate.toString() + 'K'
      this.inputPreviewSetting.resolution = obj.mainWindowResolution
      this.inputPreviewSetting.frameRate = obj.mainWindowRate
      this.inputPreviewSetting.enableVbr = obj.enableVbr

      this.finalPgmPreviewSetting.bitrate = obj.mainWindowBitrate.toString() + 'K'
      this.finalPgmPreviewSetting.resolution = obj.mainWindowResolution
      this.finalPgmPreviewSetting.frameRate = obj.mainWindowRate
      this.finalPgmPreviewSetting.enableVbr = obj.enableVbr

      this.advancedSetting.quality = obj.quality
    },
    showAdvanced () {
      if (this.componentDisabled) return
      this.advancedSettingsInfo.show = true
      this.showAdvanceds = false
    },
    openDialog () {
      this.$emit('open')
    },
    handleScroll (e) {
      this.scrolNumber = e.target.scrollTop;
    },
    showGridSetting (type = 'main') {
      if (type === 'backup') {
        this.backupGridVisible = !this.backupGridVisible
      } else {
        this.visible = !this.visible
      }
      const number = -(Math.random().toFixed(5) * 100000)
      const obj = {
        show: true,
        type: 'ISSP',
        outputTitle: 'Grid Settings',
        id: this.State.mediaInitParams.addAccountId,
        targetId: number + '',
        customTag: 'commentator-default'
      }
      try {
        mediaObj.openOutput(obj)
      } catch (e) {
        console.log('mediaObj is not defined')
      }
    },
    showEditGridSetting (type = 'main') {
      if (type === 'backup') {
        this.backupGridVisible = !this.backupGridVisible
      } else {
        this.visible = !this.visible
      }
      const grid = type === 'backup' ? this.backupDefaultGrid : this.mainDefaultGrid
      this.viewSetting.id = grid.value.id
      const obj = {
        show: true,
        type: 'ISSP',
        outputTitle: 'Grid Settings',
        id: this.viewSetting.id,
        targetId: '',
        readonly: true,
        customTag: 'commentator-default'
      }
      try {
        mediaObj.openOutput(obj)
      } catch (e) {
        console.log('mediaObj is not defined')
      }
    },
    getBackupReceiverList (type, val) {
      if (type === 'filter') {
        if (this.getBackupRListTimer) clearTimeout(this.getBackupRListTimer)
        this.backupScroll.noMore = false
        this.getBackupRListParams.pageNum = 1
        this.getBackupRListParams.condition = val
        this.getBackupRListTimer = setTimeout(() => {
          this.getBackupRArray(type)
        }, 1000)
      } else if (type === 'getList') {
        this.backupLoading = true
        if (val) {
          // 再次选择下拉框默认回到最初位置
          this.getBackupRListParams.condition = ''
          this.getBackupRListParams.pageNum = 1
          this.backupScroll.noMore = false
          this.backupRList = []
          this.getBackupRArray(type)
        } else {
          this.getBackupRListParams.condition = ''
        }
      } else if (type === undefined) {
        this.getBackupRListParams.pageNum++
        this.getBackupRArray(type)
      }
    },
    getBackupRArray (type) {
      if (this.backupScroll.noMore && !type) return
      this.backupScroll.loading = true
      this.$http
        .post('/commentator-backend/user/source/output/receiver/page', this.getBackupRListParams)
        .then(res => {
          const { errorCode } = res.data
          if (errorCode === '0x0') {
            if (type) {
              this.backupRList = res.data.result.list || []
            } else {
              this.backupRList = this.backupRList.concat(res.data.result.list)
            }
            this.backupScroll.noMore = !res.data.result.hasNextPage
          }
          this.backupScroll.loading = false
          this.backupLoading = false
        })
    },
    // 物理R下拉框出现调用
    getReceiverList (type, val) {
      if (type === 'filter') {
        if (this.getRListTimer) clearTimeout(this.getRListTimer)
        this.scroll.noMore = false
        this.getRListParams.pageNum = 1
        this.getRListParams.condition = val
        this.getRListTimer = setTimeout(() => {
          this.getRArray(type)
        }, 1000)
      } else if (type === 'getList') {
        this.loading = true
        if (val) {
          // 再次选择下拉框默认回到最初位置
          this.getRListParams.condition = ''
          this.getRListParams.pageNum = 1
          this.scroll.noMore = false
          this.rList = []
          this.getRArray(type)
        } else {
          this.getRListParams.condition = ''
        }
      } else if (type === undefined) {
        this.getRListParams.pageNum++
        this.getRArray(type)
      }
    },
    getRArray (type) {
      if (this.scroll.noMore && !type) return
      this.scroll.loading = true
      this.$http
        .post('/commentator-backend/user/source/output/receiver/page', this.getRListParams)
        .then(res => {
          const { errorCode } = res.data
          if (errorCode === '0x0') {
            if (type) {
              this.rList = res.data.result.list || []
            } else {
              this.rList = this.rList.concat(res.data.result.list)
            }
            this.scroll.noMore = !res.data.result.hasNextPage
          }
          this.scroll.loading = false
          this.loading = false
        })
    },
    getNextList () {
      this.$refs.selectScroll.getNextPage()
    },
    getSourceInfo (val, type) {
      if (this.$refs.selectScroll && type === 'main') {
        this.$refs.selectScroll.setSelectSourceDefault()
      }
      if (this.$refs.backupSelectScroll && type === 'backup') {
        this.$refs.backupSelectScroll.setSelectSourceDefault()
      }
      this.inputType = val
      if (type === 'main') {
        this.receiverInputType = val
        this.requestInfo.url = (val === 'sdi' ? this.requestSource.sdi.url : this.requestSource.ext.url) + `/${this.receiverPeerId}`
      } else {
        this.backupReceiverInputType = val
        this.backupRequestInfo.url = (val === 'sdi' ? this.requestSource.sdi.url : this.requestSource.ext.url) + `/${this.backupReceiverPeerId}`
      }
    },
    async defaultSet (val) {
      // 切换物理R和pp时清空默认值
      if (this.$refs.selectScroll) {
        this.$refs.selectScroll.setSelectSourceDefault()
      }
      this.fileInfo.id = ''
      if (!val) {
        this.inputType = 'vfb'
        this.receiverPeerId = ''
        this.receiverInputType = ''
        this.backupReceiverInputType = ''
        this.purpose = 1
        this.receiverBackupBtnVal = false
        const request = this.requestSource.vfb
        this.requestInfo = JSON.parse(JSON.stringify(request))
        this.backupRequestInfo = {}
      } else {
        this.backupBtnVal = false
        this.purpose = 1
        this.receiverInputType = 'sdi'
        this.backupReceiverInputType = 'sdi'
        const request = this.requestSource.sdi
        this.requestInfo = JSON.parse(JSON.stringify(request))
        this.backupRequestInfo = {}
      }
      if (this.$refs.receiverCheckFeature) {
        this.$refs.receiverCheckFeature.setDefault()
      }
      if (this.$refs.backupReceiverCheckFeature) {
        this.$refs.backupReceiverCheckFeature.setDefault()
      }
    },
    async getRList (val, key) {
      const isMainSelect = key === 'main'
      const typeObj = isMainSelect ? this.receiverInputType : this.backupReceiverInputType
      this.changeInputType(typeObj, key)
      if (isMainSelect) {
        this.requestInfo.url = (typeObj === 'sdi' ? this.requestSource.sdi.url : this.requestSource.ext.url) + `/${this.receiverPeerId}`
      } else {
        this.backupRequestInfo.url = (typeObj === 'sdi' ? this.requestSource.sdi.url : this.requestSource.ext.url) + `/${this.backupReceiverPeerId}`
      }
      const hadFeature = isMainSelect ? await this.$refs.receiverCheckFeature.checkRFeature(this.receiverPeerId) : await this.$refs.backupReceiverCheckFeature.checkRFeature(this.backupReceiverPeerId)
      if (hadFeature) {
        if (isMainSelect) {
          this.rList.forEach(item => {
            if (item.peerId == val) {
              this.receiverOutputName = item.name
            }
          })
        } else {
          this.backupRList.forEach(item => {
            if (item.peerId == val) {
              this.backupReceiverOutputName = item.name
            }
          })
        }
      } else {
        isMainSelect ? this.receiverOutputName = '' : this.backupReceiverOutputName = ''
      }
      if (isMainSelect) {
        if (this.$refs.selectScroll) {
          this.$refs.selectScroll.setSelectSourceDefault()
        }
        if (this.selectInputRecord[this.inputType]) {
          this.selectInputRecord[this.inputType].id = ''
          this.selectInputRecord[this.inputType].name = ''
        }
      } else {
        if (this.$refs.backupSelectScroll) {
          this.$refs.backupSelectScroll.setSelectSourceDefault()
        }
        if (this.selectInputRecord.backupReceiver) {
          this.selectInputRecord.backupReceiver.id = ''
          this.selectInputRecord.backupReceiver.name = ''
        }
      }
    },
    changeReceiverSetting (val, info) {
      this.receiverSetting.show = val
      this.receiverSetting.info = info
    },
    closeReceiverSetting () {
      this.receiverSetting.show = false
    },
    reuseEvent () {
      this.isReuse = true
      this.startTime = ''
      this.endTime = ''
      this.audioMixer = ''
      this.eventInfo.ppUrl = ''
      if (this.producerSettingsDto && this.producerSettingsDto.elasticIp && !this.isUnbind) {
        this.editElasticIP = false
      }
    },
    changeTime () {
      if (this.durationType.unit == 'min') {
        if (this.duration > 100 * 60) {
          this.duration = 100 * 60
        }
        if (this.duration < 10) {
          this.duration = 10
        }
      }
      if (this.durationType.unit == 'hour') {
        if (this.duration > 100) {
          this.duration = 100
        }
        if (this.duration < 1) {
          this.duration = 1
        }
      }
    },
    changeProductionRedundancy (val) {
      if (val) {
        if (this.backupRegion) {
          this.getZoneList('backup')
        }
      } else {
        this.backupRegion = ''
        this.backupZone = ''
        this.backupZoneList = []
        this.isShowBackupElasticIP = false
        this.backupElasticIp = ''
      }
    },
    changeBackupBtn () {
      // 取消勾选backup清除数据
      if (!this.receiverBackupBtnVal) {
        this.backupReceiverPeerId = ''
      }
      if (!this.requestBackupInfo.url && this.backupBtnVal) {
        this.getRequest('backup')
      }
    },
    applyInputType () {
      if (!this.activeApply) {
        return
      }
      const platform = this.receiverPeerId && this.receiverType == '1' ? 1 : 0
      this.$http
        .post(
          `/commentator-backend/event/v2/input/switch/${this.info.id}/${this.purpose}?clientId=${this.State.clientId}&platform=${platform}`
        )
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            this.$message.success(this.$t('eventList.switchInputSuccess'))
            this.eventInfo.mainWindowType = this.purpose
          }
        })
    },
    searchOutputFn () {
      if (this.searchOutputType == 1) {
        this.searchOutputTypeLabel = 'Receiver' + Math.random()
        this.receiverRequest.params.pageNum = 1
        this.receiverRequest.params.condition = this.searchOutput
      } else {
        this.searchOutputTypeLabel = 'IP OUT' + Math.random()
        try {
          mediaObj.updataSocial({
            nickName: this.searchOutput
          })
          this.showCaret = true
        } catch (e) {
          console.log('mediaObj is not defined')
        }
      }
    },
    hidePopup () {
      if (this.$refs.popoverGrid) {
        this.$refs.popoverGrid.doClose() // 关闭popover
      }
    },
    closeGridSettingDialog () {
      this.viewSetting.show = false
      this.showCreateDialog = false
    },
    selectSourceType (val) {
      if (this.info.type == 'reuse' && !this.isReuse) return
      this.purpose = val
    },
    outputCallback (obj) {
      const { id, name, outputType } = obj
      const params = {
        id,
        name,
        type: outputType
      }
      if (obj.type == 'add') {
        if (obj.output == 'Receiver') {
          this.selectOutputR.push(params)
        }
        if (obj.output == 'IP OUT') {
          this.selectOutputIP.push(params)
        }
      } else if (obj.deleteType) {
        this.cancelSelectedR = []
      } else {
        if (obj.output == 'Receiver') {
          this.selectOutputR = this.selectOutputR.filter((v) => v.id != obj.id)
        }
        if (obj.output == 'IP OUT') {
          this.selectOutputIP = this.selectOutputIP.filter(
            (v) => v.id != obj.id
          )
        }
      }
      console.info(548, obj)
    },
    changeInputType (val, type, key) {
      this.rtmpBackType = type
      if (type == 'backup') {
        this.backupType = val
        if (val == 'rtmp') {
          // 显示rtmp弹窗,隐藏create弹窗
          this.rtmpPushInfoBackup.show = true
          this.showAdvanceds = false
        }
      } else {
        if (val != 'sdi' && val != 'ext') {
          this.receiverPeerId = ''
          this.backupReceiverPeerId = ''
        }
        this.inputType = val
        if (val == 'file') {
          this.backupTypeList.forEach((v) => {
            v.options.forEach((val, index) => {
              if (val.value == 'file') {
                this.$set(val, index, { ...val, disabled: true })
              }
            })
          })
        }
        if (val == 'rtmp') {
          // 显示rtmp弹窗,隐藏create弹窗
          this.rtmpPushInfo.show = true
          this.showAdvanceds = false
        }
      }
      if (val != 'file') {
        this.getRequest(type, key)
      } else {
        this.producerSettingsDto.region = this.fileInfo.region || localStorage.getItem('region')
      }
    },
    // 显示rtmp,隐藏create弹窗
    showRtmp (val) {
      this.rtmpBackType = val
      this.rtmpPushInfo.show = true
      this.showAdvanceds = false
    },
    showRtmpBackUp (val) {
      this.rtmpBackType = val
      this.rtmpPushInfoBackup.show = true
      this.showAdvanceds = false
    },
    getRequest (type, key) {
      // 获取请求url和参数
      let request = {}
      let sourceType = null

      if (type == 'backup') {
        sourceType = this.backupType
      } else {
        sourceType = this.inputType
      }
      if (sourceType == 'vfb') {
        request = this.requestSource.vfb
      } else if ((sourceType == 'ext' || sourceType == 'grid') && this.receiverType != 1) {
        request = this.requestSource.pp
      } else if (sourceType == 'pack' || sourceType == 'anywhere') {
        request = this.requestSource.cc
      } else if (sourceType == 'slot') {
        request = this.requestSource.slot
      } else if (sourceType == 'sdi') {
        request = this.requestSource.sdi
      } else if (sourceType == 'rtmp') {
        request = this.requestSource.rtmp
      } else if (sourceType == 'ext' && this.receiverType === 1) {
        request = this.requestSource.ext
      }

      if (type == 'backup') {
        this.requestBackupInfo = JSON.parse(JSON.stringify(request))
        this.requestBackupInfo.id = this.selectBackupRecord[this.backupType]
          ? this.selectBackupRecord[this.backupType].id
          : ''
        if (
          this.sourceTypePamrs[this.backupType] &&
          this.sourceTypePamrs[this.backupType].value
        ) {
          this.requestBackupInfo.params.sourceType = this.sourceTypePamrs[
            this.backupType
          ].value
        }
        this.backupRequestInfo = JSON.parse(JSON.stringify(request))
        this.backupRequestInfo.id = this.selectBackupRecord[this.backupType] ? this.selectBackupRecord[this.backupType].id : ''
      } else {
        if ((this.inputType == 'sdi' || this.inputType == 'ext') && this.receiverType === 1) {
          if (key === 'main') {
            this.requestInfo = JSON.parse(JSON.stringify(request))
            this.requestInfo.id = this.selectInputRecord[this.inputType] ? this.selectInputRecord[this.inputType].id : ''
            if (this.sourceTypePamrs[this.inputType] && this.sourceTypePamrs[this.inputType].value) {
              this.requestInfo.params.sourceType = this.sourceTypePamrs[
                this.inputType
              ].value
            }
          } else {
            this.backupRequestInfo = JSON.parse(JSON.stringify(request))
            this.backupRequestInfo.id = this.selectInputRecord.backupReceiver ? this.selectInputRecord.backupReceiver.id : ''
            if (this.sourceTypePamrs[this.inputType] && this.sourceTypePamrs[this.inputType].value) {
              this.backupRequestInfo.params.sourceType = this.sourceTypePamrs[
                this.inputType
              ].value
            }
          }
        } else {
          this.requestInfo = JSON.parse(JSON.stringify(request))
          this.requestInfo.id = this.selectInputRecord[this.inputType] ? this.selectInputRecord[this.inputType].id : ''
          if (this.sourceTypePamrs[this.inputType] && this.sourceTypePamrs[this.inputType].value) {
            this.requestInfo.params.sourceType = this.sourceTypePamrs[
              this.inputType
            ].value
          }
        }
      }
    },
    resetTime (tag) {
      if (!this.isReuse && (this.info.type == 'reuse' || this.info.type == 'edit')) {
        return
      }
      if (tag == 'now') {
        this.timeControl = false
      } else {
        this.timeControl = true
        this.startTime = this.info.id ? this.startTime : ''
        this.endTime = this.info.id ? this.endTime : ''
      }
    },
    changeDuration (val) {
      this.durationType = val
      this.duration = val.time
    },
    verifyTime (startTime) {
      let btn = true
      if (this.endTime && this.startTime && this.endTime - this.startTime < 0) {
        this.$message.error(this.$t('otherWords.endTimeGreater'))
        btn = false
      }
      if (btn && this.endTime && this.startTime && this.endTime - this.startTime < 10 * 60 * 1000) {
        this.$message.error(this.$t('eventList.eventTimeTips'))
        btn = false
      }
      if (startTime < new Date().getTime()) {
        this.startTime = new Date().getTime()
      }
      return btn
    },
    changeStartTime (startTime) {
      this.verifyTime(startTime)
    },
    changeEndTime (val) {
      const timeStr = typeof val === 'object' ? val?.getTime() : val
      // 如果结束时间前于当前时间
      if (timeStr <= new Date().getTime()) {
        this.endTime = new Date().getTime() + 60 * 60 * 1000
      }
      let startTime = 0
      if (this.startTime && this.startTime != '') {
        startTime =
          typeof this.startTime === 'number'
            ? this.startTime
            : this.startTime.getTime()
      }
      if (this.endTime <= startTime) {
        this.endTime = startTime + 60 * 60 * 1000
      }
      this.verifyTime()
    },
    async selectInputChange (val, type, backupReceiver) {
      if (type == 'backup') {
        this.$set(this.selectBackupRecord, this.backupType, val)
        if (this.backupType == 'file') {
          this.backupFileInfo = val
        }
        // 去除selectInputRecord里面和用户所选择的slot值相同的属性
        if (this.selectInputRecord && this.selectInputRecord.slot) {
          if (this.selectInputRecord.slot.id === val.id) {
            delete this.selectInputRecord.slot
          }
        }
        // 禁止用户在输入源中选择和备用输入中一样的slot值
        this.$set(this.disableInputSlot, '0', val.id)
        // this.$set(this.disableInput, '0', val.id)
        // 如果用户在备用输入中选择了slot5,则禁用输入源中的上传文件
        if (val.id === 's5') {
          this.disabledInputFile(true)
          this.disabledMessage = this.$t('otherWords.fileAndSlotOnlyOne')
        } else {
          this.disabledInputFile()
          this.disabledMessage = ''
        }
        // 如果用户选择了备用输入上传文件中的具体某一项，同样禁用掉输入源中的s5
        if (this.backupType === 'file') {
          this.$set(this.disableInputSlot, '0', 's5')
          this.disabledInputFile(true)
        } else if (this.backupType === 'slot') {
          this.$set(this.disableInputSlot, '0', val.id)
        } else if (this.backupType != 'vfb' && this.backupType != 'pack') {
          this.disableInputSlot = []
        }
      } else {
        if (backupReceiver) {
          this.$set(this.selectInputRecord, 'backupReceiver', val)
        } else {
          this.$set(this.selectInputRecord, this.inputType, val)
        }
        if (this.inputType == 'file') {
          this.fileInfo = val
        }
        // 去除selectBackupRecord里面和用户所选择的slot值相同的属性
        if (this.selectBackupRecord && this.selectBackupRecord.slot) {
          if (this.selectBackupRecord.slot.id === val.id) {
            delete this.selectBackupRecord.slot
          }
        }
        // 禁止用户在备用输入中选择和输入源中一样的slot值
        this.$set(this.disableBackInputSlot, '0', val.id)
        // 用户在输入源中选择了slot5,禁用backupIn的选择文件
        if (val.id === 's5') {
          this.disabledBackUpFile(true)
          this.disabledBackMessage = this.$t('otherWords.fileAndSlotOnlyOne')
        } else {
          // 用户在输入源中选择的不是slot5，则取消禁用选择文件
          this.disabledBackUpFile()
          this.disabledBackMessage = ''
        }
        // 如果用户选择了输入源上传文件中的具体某一项，同样禁用掉输入源中的s5
        if (this.inputType === 'file') {
          this.$set(this.disableBackInputSlot, '0', 's5')
          // 禁用上传文件
          this.disabledBackUpFile(true)
          await this.getFileRegion(val)
        } else if (this.inputType === 'slot') {
          this.$set(this.disableBackInputSlot, '0', val.id)
        } else if (this.inputType != 'vfb' && this.inputType != 'pack') {
          this.disableBackInputSlot = []
        }
      }
    },
    getFileRegion (val) {
      const protocol = window.location.protocol
      const url = `${protocol}//${this.State.config.urlInfo.gateway}/drive`
      this.$http
        .get(`${url}/file/get/${val.id}`)
        .then((res) => {
          if (res.data.errorCode === '0x0') {
            this.producerSettingsDto.region = res.data.result.region
            this.fileInfo.region = res.data.result.region
          }
        })
    },
    async getRegion () {
      await this.$http.get('/commentator-backend/user/region').then((res) => {
        if (res.data.errorCode == '0x0') {
          this.producerSettingsDto.region = res.data.result
          localStorage.setItem('region', res.data.result)
        }
      })
    },
    // 先获取区域列表
    async getRegionList (type) {
      if (type == 'switchProvider') {
        this.producerSettingsDto.region = ''
        this.producerSettingsDto.zone = ''
        this.zoneList = []
        this.backupRegion = ''
        this.backupZone = ''
        this.backupZoneList = []
      }
      await this.$http
        .get(`https://${this.State.config.urlInfo.gateway}/newppapi/user/available-regions/${this.$i18n.locale}?platform=${this.producerSettingsDto.platform}`)
        .then(async (res) => {
          if (res.data.errorCode == '0x0') {
            this.regionList = res.data.result
            if (!type) {
            // 查找用户ip所在的region是否在返回的region列表中
              const allNotEqual = this.regionList.every(item => item.value != this.producerSettingsDto.region)
              if (allNotEqual) {
                await this.getRegion()
              }
              this.getZoneList('main')
            }
          }
        })
    },
    // 获取云提供者列表
    async getProviderList () {
      await this.$http
        .get(`https://${this.State.config.urlInfo.gateway}/newppapi/user/available-providers`)
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            this.providerList = res.data.result || []
          }
        })
    },
    // 根据选择区域获取区域下的可用区
    getZoneList (type = 'main') {
      const isBackup = type === 'backup'
      const region = isBackup ? this.backupRegion : this.producerSettingsDto.region
      if (this.userFeature?.zoneControl != 1 || !region || this.producerSettingsDto.platform == 2) return
      if (isBackup) {
        this.backupZoneLoading = true
      } else {
        this.zoneLoading = true
      }
      this.$http
        .get(`https://${this.State.config.urlInfo.gateway}/newppapi/user/available-zones/${region}?platform=${this.producerSettingsDto.platform}`)
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            if (isBackup) {
              this.backupZoneList = res.data.result
              this.backupZone = this.backupZoneList.length ? this.backupZoneList[0] : ''
            } else {
              this.zoneList = res.data.result
              this.producerSettingsDto.zone = this.zoneList.length ? this.zoneList[0] : ''
            }
          }
        })
        .finally(() => {
          if (isBackup) {
            this.backupZoneLoading = false
          } else {
            this.zoneLoading = false
          }
        })
    },
    async getEventInfo (id) {
      if (!this.info.id) return
      const eventId = id || this.info.id
      this.scrollS.loading = true
      await this.$http
        .post(`/commentator-backend/event/v2/${eventId}`)
        .then(async (res) => {
          this.showDetail = true
          this.getMediaOutPutList()
          if (res.data.errorCode == '0x0') {
            const result = res.data.result
            this.eventInfo = res.data.result
            this.addHostAndPipEmail()
            this.eventRid = res.data.result.rid
            if (result.partyExtendInfoVO) {
              this.invitedInfo = result.partyExtendInfoVO
            }
            // 用于实时更新mainwindow结束时间
            this.$emit('updateEndTime', this.eventInfo.endTime)
            // 判断是否需要编辑ipout
            if (this.eventInfo.status >= 4) {
              this.showEditIpout = false
            }
            this.eventInfo.receivers.forEach(item => {
              this.rLiveIsspInfo[item.id] = item.pushLiveUrl
            })
            const {
              title,
              startTime,
              endTime,
              description,
              eventParties,
              audioMixTaskId,
              id,
              inputList,
              mainWindowType,
              producerSettingsDto,
              receivers,
              productionId,
              advancedSetting,
              inputPreviewSetting,
              finalPgmPreviewSetting
            } = this.eventInfo
            this.title = title
            this.startTime = startTime
            this.endTime = endTime
            // 双pgm事件，region和zone只从inputList获取，不使用producerSettingsDto的值
            if (producerSettingsDto) {
              this.isDualPgm = inputList && inputList.filter(item => item.type === 'pgm').length >= 2
              if (this.isDualPgm) {
                const { region, zone, ...rest } = producerSettingsDto
                Object.assign(this.producerSettingsDto, rest)
              } else {
                this.producerSettingsDto = producerSettingsDto
              }
            }
            // 等待eventInfo获取后，查询ip数据再做对比
            await this.getElasticIp()
            this.scrollS.loading = false
            this.inputPreviewSetting = inputPreviewSetting || this.inputPreviewSetting
            this.finalPgmPreviewSetting = finalPgmPreviewSetting || this.finalPgmPreviewSetting
            // 比特率，码率，分辨率
            this.State.advanceSettingInfo.mainWindowBitrate = Number(this.inputPreviewSetting.bitrate.replace('K', ''))
            this.State.advanceSettingInfo.mainWindowResolution = this.inputPreviewSetting.resolution
            this.State.advanceSettingInfo.mainWindowRate = this.inputPreviewSetting.frameRate
            this.State.advanceSettingInfo.enableVbr = this.inputPreviewSetting.enableVbr

            this.State.advanceSettingInfo.mainWindowBitrate = Number(this.finalPgmPreviewSetting.bitrate.replace('K', ''))
            this.State.advanceSettingInfo.mainWindowResolution = this.finalPgmPreviewSetting.resolution
            this.State.advanceSettingInfo.mainWindowRate = this.finalPgmPreviewSetting.frameRate
            this.State.advanceSettingInfo.enableVbr = this.finalPgmPreviewSetting.enableVbr

            this.State.advanceSettingInfo.audioChannelNum = this.producerSettingsDto.audioChannelNum
            this.State.advanceSettingInfo.bitrateValue = this.producerSettingsDto.delay
            this.State.advanceSettingInfo.checkedRps = this.producerSettingsDto.rps
            this.State.advanceSettingInfo.checkedPgmRecording = this.producerSettingsDto.pgmRecording
            this.State.advanceSettingInfo.checkedPartyline = this.producerSettingsDto.partyLine
            this.State.advanceSettingInfo.checkedReplayApp = this.producerSettingsDto.replayApp
            this.State.advanceSettingInfo.checkedOutPutBuffer = this.producerSettingsDto.outputDelay
            this.State.advanceSettingInfo.outPutBufferValue = this.producerSettingsDto.outputDelayTime
            this.State.advanceSettingInfo.checkedInputSourceRecording = this.producerSettingsDto.cloudRecord
            if (advancedSetting) {
              this.State.advanceSettingInfo.advancedSetting = advancedSetting
              this.qualityFeature = true
            } else {
              this.qualityFeature = false
            }

            if (res.data.result.ppDomainUrl) {
              this.domain = res.data.result.ppDomainUrl.split('//')[1]
              this.$store.commit('setDomain', this.domain)
            }
            if (this.producerSettingsDto.recordSources) {
              this.State.advanceSettingInfo.cloudRecordChecked = this.producerSettingsDto.recordSources.split(',')
            }
            if (this.eventInfo.status == 4) {
              try {
                mediaObj.rId = this.eventInfo.rid
              } catch (e) {
                console.log('mediaObj is not defined')
              }
            } else {
              try {
                mediaObj.rId = ''
              } catch (e) {
                console.log('mediaObj is not defined')
              }
            }
            if (producerSettingsDto && producerSettingsDto.elasticIp) {
              this.isShowElasticIP = true
              this.editElasticIP = true
            }
            this.description = description
            // 拼接audioMixerUrl
            if (this.Config.urlInfo.audioMixerUrl && audioMixTaskId) {
              const pgmInput = inputList.filter(item => {
                return item.type === 'pgm'
              })
              if (pgmInput.length >= 2) {
                this.audioMixer = this.Config.urlInfo.audioMixerUrl + '/' + id
              } else {
                this.audioMixer = this.Config.urlInfo.audioMixerUrl + '/' + audioMixTaskId
              }
            }
            if (this.Config.urlInfo.producerStudioUrl && productionId) {
              this.eventInfo.ppUrl = this.Config.urlInfo.producerStudioUrl + productionId
            }
            this.partyList = eventParties ? JSON.parse(JSON.stringify(eventParties)) : []
            this.selectOutputR = this.eventInfo.receivers || []
            if (this.$refs.outPutList) {
              this.$refs.outPutList.getList()
            }
            this.$store.state.mediaInitParams.selectedOutput = this.eventInfo.templates || []
            this.$store.state.mediaInitParams.selectedOutput = this.$store.state.mediaInitParams.selectedOutput.filter(
              value => value.name !== 'Default Grid')
            this.$store.state.mediaInitParams.selectedOutput.forEach(info => {
              receivers.forEach(item1 => {
                if (item1.liveOutputId == info.id) {
                  this.$set(info, 'disabled', true)
                }
              })
            })
            this.purpose = mainWindowType
            let btn = false
            inputList &&
              inputList.forEach((val) => {
                const { purpose, type, value } = val
                if (purpose == 1) {
                  btn = true
                  this.inputType = type
                  if (type == 'file') {
                    this.changeRtmpType = ''
                    this.fileInfo.name = value.name
                    this.fileInfo.id = value.id
                  } else if (type == 'rtmp') {
                    // rtmp弹窗数据
                    this.selectInputRecord[this.inputType] = value
                    this.changeRtmpType = 'rtmp'
                    this.getRequest(type)
                    this.State.rtmpName = value.name
                    this.State.serverValue = value.server
                    this.State.keyValue = value.key
                  } else if (type === 'sdi' || type == 'ext') {
                    this.receiverInputType = type
                    if (value.name.includes('ST2110')) {
                      this.typeList = this.typeList.filter(item => item.val !== 'sdi')
                      this.typeList.unshift({
                        label: '2110',
                        val: 'sdi'
                      })
                    }
                  } else if (type === 'pgm' && this.isDualPgm) {
                    this.producerSettingsDto.region = val.region
                    this.producerSettingsDto.zone = val.zone
                  } else {
                    this.changeRtmpType = ''
                    this.selectInputRecord[this.inputType] = value
                    this.getRequest(type)
                    this.requestInfo.name = value ? value.name : null
                    this.backupRequestInfo.name = value ? value.name : null
                  }
                }
                if (purpose == 2) {
                  // 如果是 sdi 需要同步 inputType
                  if (type === 'sdi') {
                    this.inputType = type
                    if (value.name.includes('ST2110')) {
                      this.backUpInTypeList = this.backUpInTypeList.filter(item => item.val !== 'sdi')
                      this.backUpInTypeList.unshift({
                        label: '2110',
                        val: 'sdi'
                      })
                    }
                  }
                  if (type == 'ext') {
                    this.backupReceiverInputType = type
                  }
                  if (type == 'file') {
                    this.changeRtmpType = ''
                    this.backupFileInfo.name = value.name
                    this.backupFileInfo.id = value.id
                  }
                  if (type === 'pgm') {
                    this.productionRedundancy = true
                    this.backupRegion = val.region
                    this.backupZone = val.zone
                  }
                  if (type != 'pgm' && type != 'rtmp' && type != 'sdi' && !(type == 'ext' && value.rid)) {
                    this.changeRtmpType = ''
                    this.backupType = type
                    this.selectBackupRecord[type] = value
                    this.receiverBackupBtnVal = true
                    this.backupBtnVal = true
                    this.getRequest('backup')
                    this.requestBackupInfo.name = value ? value.name : null
                  } else if (type == 'rtmp') {
                    this.backupType = type
                    // backup的对勾
                    this.receiverBackupBtnVal = true
                    this.backupBtnVal = true
                    // rtmp弹窗数据
                    this.selectBackupRecord[this.backupType] = value
                    this.changeRtmpType = 'rtmp'
                    this.getRequest('backup')
                    this.State.rtmpNameBackup = value.name
                    this.State.serverValueBackup = value.server
                    this.State.keyValueBackup = value.key
                  }
                }
                if (this.inputType === 'sdi' || this.inputType === 'ext') {
                  btn = true
                  if (value.rid) this.receiverType = 1
                  if (purpose == 1) {
                    this.receiverPeerId = value.rid
                    this.selectInputRecord[this.inputType] = value
                    this.receiverOutputName = value.receiverName
                    this.getRequest(type, 'main')
                    this.requestInfo.name = value ? value.name : null
                    this.requestInfo.url = this.inputType === 'ext' ? this.requestInfo.url : this.requestInfo.url + `/${this.eventInfo.rid}`
                  } else {
                    this.getRequest(type)
                    this.selectInputRecord.backupReceiver = value
                    this.receiverBackupBtnVal = true
                    this.backupReceiverInputType = type
                    this.backupRequestInfo.name = value ? value.name : null
                    this.backupReceiverPeerId = value.rid
                    this.backupReceiverOutputName = value.receiverName
                    this.backupRequestInfo.url = this.inputType === 'ext' ? this.backupRequestInfo.url : this.backupRequestInfo.url + `/${value.rid}`
                  }
                }
              })
            if (!btn) {
              this.getRequest('input')
            }
            this.getFeatureInfo()
          }
        })
    },
    // 获取checkfeature相关状态
    getFeatureInfo () {
      this.$nextTick(() => {
        if (this.receiverBackupBtnVal) {
          if (this.$refs.receiverCheckFeature && this.receiverPeerId) {
            this.$refs.receiverCheckFeature.checkRFeature(this.receiverPeerId)
          }
          if (this.$refs.backupReceiverCheckFeature && this.backupReceiverPeerId) {
            this.$refs.backupReceiverCheckFeature.checkRFeature(this.backupReceiverPeerId)
          }
        } else {
          if (this.$refs.receiverCheckFeature && this.receiverPeerId) {
            this.$refs.receiverCheckFeature.checkRFeature(this.receiverPeerId)
          }
        }
      })
    },
    showInvite () {
      if (this.eventInfo.collaborateType == '2') return
      this.inviteInfo.show = true
    },
    addGroup () {
      if (this.eventInfo.collaborateType == '2') return
      this.partyList.push({ partyCode: '', title: '' })
    },
    deleteFn (key) {
      if (this.eventInfo.collaborateType == '2') return
      this.partyList.splice(key, 1)
    },
    copyLink (val, type) {
      if (type == 'partyCode') {
        const domain = window.location.host
        return (
          'https://' +
          domain +
          '/commentator?join_id=' +
          val.partyCode
        )
      } else {
        return val
      }
    },
    onCopy () {
      this.hidePopup()
      this.$message({
        message: this.$t('otherWords.copySuccess'),
        type: 'success'
      })
    },
    onError () {
      this.$message({
        message: 'Copy failed',
        type: 'error'
      })
    },
    done () {
      this.State.hasAssignCoHostEmails = []
      this.info.show = false
      if (this.info.show == false && this.advancedSettingsInfo.show == false) {
        this.State.advanceSettingInfo = {
          bitrateValue: 2,
          mainWindowBitrate: 2000,
          mainWindowResolution: '1280x720',
          mainWindowRate: '30',
          checkedRps: 0,
          checkedPartyline: 0,
          checkedPgmRecording: 1,
          checkedReplayApp: 0,
          checkedOutPutBuffer: 0,
          outPutBufferValue: 2,
          checkedInputSourceRecording: 0,
          cloudRecordChecked: [],
          advancedSetting: {
            quality: '360p'
          },
          audioChannelNum: '8'
        }
      }
      if (this.info.show == false && (this.rtmpPushInfo.show == false || this.rtmpPushInfoBackup.show == false)) {
        this.State.rtmpName = ''
        this.State.serverValue = ''
        this.State.keyValue = ''
        this.State.rtmpNameBackup = ''
        this.State.serverValueBackup = ''
        this.State.keyValueBackup = ''
      }
      this.$emit('closeDialog')
    },
    getInputOutputData (isspId) {
      const eventInputDto = []
      const eventOutputDto = []
      const isDuublePgm = this.inputType == 'pgm' && this.productionRedundancy
      // 组装input数据
      if (
        (this.selectInputRecord[this.inputType] && this.selectInputRecord[this.inputType].id) ||
        (this.selectInputRecord.backupReceiver && this.selectInputRecord.backupReceiver.id) ||
        this.inputType == 'pgm'
      ) {
        if (this.inputType === 'sdi' || this.inputType === 'ext') {
          const selectReceiverInfo = this.rList && this.rList.filter(item => {
            return item.peerId == this.receiverPeerId
          })
          const selectInput = this.receiverType == 1 ? this.receiverInputType : this.inputType
          eventInputDto.push({
            purpose: 1,
            type: selectInput,
            value: { ...this.selectInputRecord[selectInput], rid: this.receiverPeerId, receiverName: this.eventInfo.collaborateType == '2' ? this.selectInputRecord[selectInput].receiverName : selectReceiverInfo[0] && selectReceiverInfo[0]?.name }
          })
          // 增加发送 backup receiver 数据
          if (this.receiverBackupBtnVal && this.selectInputRecord.backupReceiver && this.selectInputRecord.backupReceiver.id) {
            const selectBkReceiverInfo = this.backupRList && this.backupRList.filter(item => {
              return item.peerId == this.backupReceiverPeerId
            })
            eventInputDto.push({
              purpose: 2,
              type: this.receiverType == 1 ? this.backupReceiverInputType : this.inputType,
              value: { ...this.selectInputRecord.backupReceiver, rid: this.backupReceiverPeerId, receiverName: this.eventInfo.collaborateType == '2' ? this.selectInputRecord.backupReceiver.receiverName : selectBkReceiverInfo[0]?.name }
            })
          }
        } else if (this.inputType == 'pgm') {
          if (isDuublePgm) {
            eventInputDto.push(
              {
                purpose: 1,
                type: 'pgm',
                region: this.producerSettingsDto.region,
                zone: this.producerSettingsDto.zone
              },
              {
                purpose: 2,
                type: 'pgm',
                region: this.backupRegion,
                zone: this.backupZone
              }
            )
          } else {
            eventInputDto.push({
              purpose: 1,
              type: 'pgm'
            })
          }
        } else {
          eventInputDto.push({
            purpose: 1,
            type: this.inputType,
            value: this.selectInputRecord[this.inputType]
          })
        }
      }
      // backUp
      if (this.backupBtnVal && (this.selectBackupRecord[this.backupType] || this.backupType == 'pgm')) {
        if (!eventInputDto.some(item => item.type === 'pgm')) {
          eventInputDto.push({
            purpose: 2,
            type: this.backupType,
            value: this.selectBackupRecord[this.backupType]
          })
        }
      }
      if (this.selectOutputR.length || this.$store.state.mediaInitParams.selectedOutput.length) {
        this.selectOutputR.forEach((v) => {
          isspId ? v.liveOutputId = isspId : v.liveOutputId = ''
          eventOutputDto.push({
            type: 'receiver',
            value: v
          })
        })
        this.$store.state.mediaInitParams.selectedOutput = this.$store.state.mediaInitParams.selectedOutput.filter(
          value => value.name !== 'Default Grid')
        this.$store.state.mediaInitParams.selectedOutput.forEach(value => {
          value.name = value.nickName
          eventOutputDto.push({
            type: 'ip_out',
            value
          })
        })
      }

      return { eventInputDto, eventOutputDto }
    },
    controlLiveIssp (isspId) {
      if (isspId === 'defaultGrid') return
      this.selectIsspId = isspId
    },
    async save () {
      // 清除advanceSetting数据
      this.State.advanceSettingInfo = {
        bitrateValue: 2,
        mainWindowBitrate: 2000,
        mainWindowResolution: '1280x720',
        mainWindowRate: '30',
        checkedRps: 0,
        checkedPgmRecording: 1,
        checkedPartyline: 0,
        checkedReplayApp: 0,
        checkedOutPutBuffer: 0,
        outPutBufferValue: 2,
        checkedInputSourceRecording: 0,
        cloudRecordChecked: [],
        advancedSetting: {
          quality: '360p'
        },
        audioChannelNum: '8'
      }
      // 获取组装的input、output数据
      const { eventInputDto, eventOutputDto } = this.getInputOutputData(this.selectIsspId)
      const _this = this
      const isDoublePgm = this.inputType == 'pgm' && this.productionRedundancy
      console.info(
        this.selectInputRecord,
        this.selectOutputR,
        this.selectOutputIP,
        this.producerSettingsDto,
        eventInputDto,
        eventInputDto.filter((v) => v.purpose == 1)
      )
      if (this.inputType === 'sdi' || (this.inputType === 'ext' && this.receiverType == 1)) {
        if (
          !_this.partyList.filter((v) => v.title).length || !_this.title ||
          (!_this.startTime && _this.timeControl) ||
          (!_this.endTime && _this.timeControl) ||
          !eventInputDto.filter((v) => v.purpose == 1).length ||
          (!eventInputDto.filter((v) => v.purpose == 2).length && this.receiverBackupBtnVal) ||
          !this.receiverOutputName ||
          (!this.backupReceiverOutputName && this.receiverBackupBtnVal)
        ) {
          this.$message.error(this.$t('eventList.createEventTips'))
          return
        }
      } else {
        const purposeOneItems = eventInputDto.filter((v) => v.purpose == 1)
        const purposeOneItemsBackup = eventInputDto.filter((v) => v.purpose == 2)
        const rtmpItems = purposeOneItems.filter((v) => v.type == 'rtmp')
        const rtmpItemsBackup = purposeOneItemsBackup.filter((v) => v.type == 'rtmp')
        if (
          (_this.isShowElasticIP && !_this.producerSettingsDto.elasticIp) ||
          !_this.title ||
          !_this.producerSettingsDto.region ||
          (!_this.isShowElasticIP && this.producerSettingsDto.platform != 2 && !_this.producerSettingsDto.zone && _this.userFeature.zoneControl == 1) ||
          !_this.partyList.filter((v) => v.title).length ||
          (!_this.startTime && _this.timeControl) ||
          (!_this.endTime && _this.timeControl) ||
          !eventInputDto.length ||
          (!eventInputDto.filter((v) => v.purpose == 1).length && !isDoublePgm) ||
          (rtmpItems.some((v) => !v.value.name || !v.value.key)) ||
          (rtmpItemsBackup.some((v) => !v.value.name || !v.value.key)) ||
          (!purposeOneItemsBackup.length && this.backupBtnVal)
        ) {
          this.$message.error(this.$t('eventList.createEventTips'))
          return
        }
      }
      // 清除rtmp数据
      this.State.rtmpName = ''
      this.State.serverValue = ''
      this.State.keyValue = ''
      this.State.rtmpNameBackup = ''
      this.State.serverValueBackup = ''
      this.State.keyValueBackup = ''
      // 验证时间
      if (!this.verifyTime()) return
      // 获取当前服务的时间
      if (!this.timeControl) {
        await this.$http
          .post('/commentator-backend/event/v2/system/time')
          .then((res) => {
            if (res.data.errorCode == '0x0') {
              if (this.info.type === 'creat' || this.isReuse) {
                this.startTime = res.data.result
              }
              let unitTime = 60 * 1000
              if (this.durationType.unit == 'hour') {
                unitTime = 60 * 60 * 1000
              }
              this.endTime = this.startTime + parseInt(this.duration) * unitTime
              // this.endTime = !(this.durationType - 1)
              //   ? this.startTime + 30 * 60 * 1000
              //   : this.startTime + (this.durationType - 1) * 60 * 60 * 1000
            }
          })
      }
      if (this.receiverType == '1') {
        const { replayApp, pgmRecording, rps, outputDelayTime, outputDelay, ...updatedProducerSettingsDto } = this.producerSettingsDto;
        this.producerSettingsDto = updatedProducerSettingsDto
      }
      const params = {
        startTime: this.startTime,
        endTime: this.endTime,
        producerSettingsDto: this.producerSettingsDto,
        inputPreviewSetting: this.inputPreviewSetting,
        finalPgmPreviewSetting: this.finalPgmPreviewSetting,
        title: this.title,
        description: this.description,
        record: 1,
        eventInputDto,
        eventOutputDto,
        mainWindowType: (this.backupBtnVal && this.receiverType != '1') || (this.receiverBackupBtnVal && this.receiverType == '1') || (this.productionRedundancy && this.inputType === 'pgm') ? this.purpose : 1,
        platform: this.receiverPeerId && this.receiverType == '1' ? 1 : 0,
        rid: this.receiverPeerId,
        coHost: this.coHost
      }
      if (this.qualityFeature) {
        params.advancedSetting = this.advancedSetting
      }
      if (!this.info.id) {
        if (this.createLoading) return
        this.createLoading = true
        const array = this.partyList.filter((v) => v.title)
        if (array) {
          params.partyTitles = array.map((v) => v.title)
        }
        if (this.State.mediaInitParams.addAccountId) {
          const obj = {
            type: 'ip_out',
            value: {
              id: this.State.mediaInitParams.addAccountId,
              type: 'G'
            }
          }
          eventOutputDto.push(obj)
        }
        this.$http
          .post('/commentator-backend/event/v2/create', params, { errorTips: false })
          .then((res) => {
            if (res.data.errorCode == '0x0') {
              this.showGroupLink = true
              this.dialogTitle = this.$t('eventList.groupLink')
              this.partyList = res.data.result.eventPartyList
              this.invitedInfo = {
                inviteMode: 0,
                partyCode: res.data.result.parentPartyCode

              }
              this.$emit('callback', { type: 'create' })
              // 调用父组件上面的websocket方法
              // this.$parent.sendWebsocketMessage(true);
              // 创建事件之后跳转至第一页
              this.$message({
                dangerouslyUseHTMLString: true,
                message:
                  this.$t('eventList.createEventSuccess') + `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong><span style='text-decoration:underline;font-weight:900; cursor:pointer'>${this.$t('eventList.viewEvent')}</span></strong>`,
                type: 'success'
              }).$el.querySelector('span').onclick = () => {
                this.$emit('callback', { type: 'pagination' })
              }
            } else if (res.data.errorCode == '82302008') {
              this.$message.error(this.$t('eventList.eventRemaining'))
            } else {
              if (res.data.errorCode == '82301008') {
                // this.createFailedInfo.show = true
                this.receiverConflictErrorCode = res.data.errorCode
                this.receiverConflictInfo.show = true
                this.receiverConflictInfo.data = res.data.result
              } else if (res.data.errorCode == '82301017') {
                this.receiverConflictErrorCode = res.data.errorCode
                this.receiverConflictInfo.show = true
                this.receiverConflictInfo.data = res.data.result
              } else if (res.data.errorCode == '82301009') {
                this.sourceConflictInfo.show = true
                this.sourceConflictInfo.data = res.data.result
              } else {
                this.$message.error(res.data.errorInfo)
              }
            }
            this.createLoading = false
          })
      } else {
        params.rid = this.eventRid
        params.eventParties = this.partyList.filter((v) => v.title)
        let url = `/commentator-backend/event/v2/update/${this.info.id}`
        if (this.isReuse) {
          url = `/commentator-backend/event/v2/reuse/${this.info.id}`
          if (!this.isShowElasticIP) {
            this.producerSettingsDto.elasticIp = ''
          }
        }
        this.$http.post(url, params, { errorTips: false }).then((res) => {
          if (res.data.errorCode == '0x0') {
            this.showGroupLink = true
            this.dialogTitle = this.$t('eventList.groupLink')
            this.partyList = res.data.result.eventPartyList
            this.$emit('callback', { type: 'update' })
            // 调用父组件的websocket方法
            // this.$parent.sendWebsocketMessage(true);
          } else {
            if (res.data.errorCode == '82301008') {
              // this.createFailedInfo.show = true
              // this.createFailedInfo.data = res.data.result
              this.receiverConflictErrorCode = res.data.errorCode
              this.receiverConflictInfo.show = true
              this.receiverConflictInfo.data = res.data.result
            } else if (res.data.errorCode == '82301017') {
              this.receiverConflictErrorCode = res.data.errorCode
              this.receiverConflictInfo.show = true
              this.receiverConflictInfo.data = res.data.result
            } else if (res.data.errorCode == '82301009') {
              this.sourceConflictInfo.show = true
              this.sourceConflictInfo.data = res.data.result
            } else {
              this.$message.error(res.data.errorInfo)
            }
          }
        })
      }
    },
    // 禁用备用输入的上传文件
    disabledBackUpFile (isDisabled) {
      if (isDisabled) {
        this.backupTypeList.forEach((v) => {
          v.options.forEach((vals, index) => {
            if (vals.value == 'file') {
              this.$set(v.options, index, { ...vals, disabled: true })
            }
          })
        })
      } else {
        // 取消禁用上传文件
        this.backupTypeList.forEach((v) => {
          v.options.forEach((vals, index) => {
            this.$set(v.options, index, { ...vals, disabled: false })
          })
        })
      }
    },
    // 禁用输入源的上传文件
    disabledInputFile (isDisabled) {
      // 禁用上传文件
      if (isDisabled) {
        this.inputTypeList.forEach((v) => {
          v.options.forEach((vals, index) => {
            if (vals.value === 'file') {
              this.$set(v.options, index, { ...vals, disabled: true })
            }
          })
        })
      } else {
        // 取消禁用上传文件
        this.inputTypeList.forEach((v) => {
          v.options.forEach((vals, index) => {
            this.$set(v.options, index, { ...vals, disabled: false })
          })
        })
      }
    },
    hideCheckedReceiver (values) {
      values.forEach(item => {
        this.selectOutputR.forEach(value => {
          if (value.id === item.receiverId) {
            this.selectOutputR.splice(this.selectOutputR.indexOf(value), 1)
            this.cancelSelectedR.push(value)
          }
        })
      })
    },
    // hideCheckedSource (values) {
    //   values.forEach(item => {
    //     this.selectOutputIP.forEach(value => {
    //       if (value.id === item.receiverId) {
    //         this.selectOutputIP.splice(this.selectOutputIP.indexOf(value), 1)
    //         this.cancelSelectedR.push(value)
    //       }
    //     })
    //   })
    // },
    getMediaOutPutList () {
      const obj = {
        type: 'OutputSetting',
        changeType: 'showOrHide',
        domId: 'mediaOutputList'
      }
      try {
        mediaObj.rId = ''
        mediaObj.shareToggle = true
        mediaObj.ignoreTargetId = true
        SM.__proto__.JumpMediaJs(obj)
      } catch (e) {
        console.log('mediaObj is not defined')
      }
    },
    changeCaret () {
      this.showCaret = !this.showCaret
      if (this.showCaret) {
        const obj = {
          type: 'OutputSetting',
          changeType: 'showOrHide',
          domId: 'mediaOutputList'
        }
        try {
          mediaObj.shareToggle = true
          SM.__proto__.JumpMediaJs(obj)
        } catch (e) {
          console.log('mediaObj is not defined')
        }
      } else {
        const mediaOutputListContainer = document.getElementById('mediaOutputList')
        if (mediaOutputListContainer) {
          const mediaOutputList = mediaOutputListContainer.querySelector('.mediaOutputBox');
          const outPutSetting = mediaOutputListContainer.querySelector('.outPutSetting');

          if (outPutSetting) {
            outPutSetting.style.display = 'none'
          }
          if (mediaOutputList) {
            mediaOutputList.style.height = 0 + 'px'
          }
        }
      }
    },
    async getElasticIp () {
      try {
        const { data } = await this.$http.get('/commentator-backend/user/findAllElasticIps')
        if (data.result.length) {
          data.result.forEach(item => {
            item.elasticIpAndRegions = item.staticIp + '    (' + item.regionName + ')'
            item.value = { ...item }
            if (item.occupied) {
              item.disabled = true
            }
          })
          this.elasticIpList = data.result
          this.judgeIsUnBindIp()
        } else {
          // 用户没有选择elasticIp的权限，禁用掉checkBox
          this.hasElasticIp = true
        }
      } catch (err) {
        console.log(err);
      }
    },
    showTips () {
      if (!this.elasticIpList.some(item => item.value.occupied === false)) {
        this.$message.error('There is no available IP, please release it to use.')
      }
    },
    async unBindElasticIP () {
      try {
        await this.$http.post(`/commentator-backend/event/v2/ip/unbind/${this.info.id}`)
        this.isUnbind = false
        // 与勾选框联动 由弹性ip变为地区的select
        this.isShowElasticIP = false
        // 解绑后更新列表数据 去除disabled状态
        this.getElasticIp()
      } catch (err) {
        this.isUnbind = true
        console.log(err);
      }
    },
    judgeIsUnBindIp () {
      const item = this.elasticIpList.find(item => item.staticIp === this.producerSettingsDto.elasticIp)
      if (item && item.occupied && item.occupiedInfo.name === this.eventInfo.title) {
        this.isUnbind = true
      }
    }
  }
}
</script>
<style lang="less" scoped>
.el-dialog__wrapper.showGroup {
  .inviteBox {
    display: flex;
    align-items: center;
    padding: 8px 15px;
    border-radius: 5px;
    margin-top: -7px;
    .el-icon-arrow-down {
      margin-left: 4px;
    }
  }
}
.thisblack-bgc {
  background-color: rgba(0, 0, 0, 0.5);
  overflow-y: hidden;
  &.showGroup {
    padding-top: 15vh;
    /deep/.el-dialog__footer {
      padding: 10px 20px 32px;
    }
  }
  &.noShowGroup {
    display: flex;
  }
}
.defaultContent {
  margin-left: 4px;
}
.checkrSucess {
  margin-top: 3px;
}
.icon-Subtract {
  font-size: 12px !important;
}
.el-icon-arrow-right,
.el-icon-arrow-down {
  margin-top: 2px;
  margin-left: -4px;
}
.tipSuceess {
  margin-left: 10px;
  div:not(.hardWareWarningMessage) {
    display: flex;
    margin-top: 3px;
  }
  div {
    justify-content: space-between;
  }
  .hardWareWarningContent {
    margin-left: -4px;
    background: #ff9a241a;
    border-radius: 2px;
    p {
      padding-left: 4px;
      word-break: break-all;
    }
  }
}
.tip {
  div {
    display: flex;
    margin-top: 3px;
    justify-content: space-between;
  }
  .onlineError,
  .singleRnote,
  .hardWareError {
    margin-left: 7px;
  }
  .receiverVersionError {
    cursor: pointer;
  }
  .receiverVersionErrorContent,
  .ipAndPortErrorContent,
  .hardWareErrorContent,
  .funtionErrorContent {
    margin-left: -4px;
    background: rgba(246, 68, 90, 0.1);
    border-radius: 2px;
    p {
      padding-left: 4px;
      word-break: break-all;
    }
  }
}
.el-icon-success {
  color: #33ab4f;
}
.el-icon-error {
  color: #fa5555;
}
</style>
